const EN = {
  // Generic actions
  'action:accept': 'Accept',
  'action:return': 'Back',
  'action:go-to-home': 'Home',
  'action:enter': 'Enter',
  'action:close': 'Close',
  'action:login': 'Log in',
  'action:search': 'Search',
  'action:logout': 'Log out',
  'action:change': 'Change',
  'action:request-shipment': 'New shipment',
  'action:download-excel-selection': 'Download selection',
  'action:visualise-selection': 'View selection',
  'action:use-new-address': 'I want to use a new address',
  'action:save-address-my-agenda': 'Save address to my address book',
  'action:delete-address-my-agenda-header': 'Delete contact',
  'action:delete-created-address-header': 'Delete contact',
  'action:delete-created-address-body':
    'Are you sure you want to delete this contact from your address book?',
  'action:delete-created-address-header-2': 'Delete address',
  'action:delete-created-address-body-2':
    'This address is not saved in your address book. Do you want to delete it?',
  'action:delete-addresses-my-agenda-header': 'Delete contacts',
  'action:delete-address-my-agenda-body':
    'Are you sure you want to delete this contact from your address book?',
  'action:delete-addresses-my-agenda-body':
    "You are about to delete {number} contacts from your address book. If you do this, we won't be able to recover them.",
  'action:delete-address-my-agenda-body-success':
    'The contact has been successfully deleted.',
  'action:delete-address-my-agenda-body-error':
    'We were unable to complete the deletion. Please try again.',
  'action:delete-addresses-my-agenda-body-success':
    'The contacts have been successfully deleted.',
  'action:retry': 'Retry',
  'action:back-to-agenda-address': 'Return to the default address',
  'action:back-to-home': 'Return to the home page',
  'action:go-to-previous-page': 'Return to the previous page',
  'action:reload-page': 'Reload this page',
  'action:want-choose-day-time': 'Select date & time',
  'action:want-choose-day-and-time': 'I want to choose a day and time',
  'action:as-soon-as-possible': 'As soon as possible',
  'action:request-later': "Request later",
  'action:unscheduled-date': 'Unscheduled',
  'action:discard': 'Discard',
  'action:discard-changes': 'Discard changes',
  'action:cancel': 'Cancel',
  'action:exit': 'Exit',
  'action:abandon-process': 'Exit the process',
  'action:delete-contacts': 'Delete {contacts}',
  'action:cancel-shipment':
    'Cancel {count, plural, one {shipment} other {shipments}}',
  'action:duplicate-shipment': 'Duplicate shipment',
  'action:activate-return': 'Request a return',
  'action:return-shipping': 'Return shipment',
  'action:upload-files': 'Select or drag a file to upload',
  'action:allowed-files':
    'Allowed formats: .XLSX, .CSV. Maximum file size: 5MB.',
  'action:uploading-files': 'Uploading file...',
  'action:download': 'Download',
  'action:label': 'Label',
  'action:procesing': 'Processing',
  'action:download-2': 'Download',
  'action:download-pod': 'Download POD',
  'action:download-albaran': 'Download Delivery Note',
  'action:import-file': 'Bulk Import',
  'action:import-files': 'Import Shipments',
  'action:importation-files': 'Import shipments',
  'action:one-shipment': 'A shipment',
  'action:import-contacts': 'Import contacts',
  'action:schedule-pickup': 'Schedule a pickup',
  'action:download-shipping-label':
    'Download {count, plural, one {label} other {labels}}',
  'action:print-shipping-label':
    'Print {count, plural, one {label} other {labels}}',
  'action:print': 'Print',
  'action:go-to-next-error': 'Go to the next error',
  'action:next-step': 'Next tab',
  'action:add-destination': 'Add destination',
  'action:save': 'Save',
  'action:save-changes': 'Save changes',
  'action:submit-from': 'Continue',
  'action:submit-to': 'Continue',
  'action:confirm': 'Confirm',
  'action:confirm-changes': 'Confirm changes',
  'action:submit-shipment': 'Continue',
  'action:submit-customs': 'Continue',
  'action:continue-importation': 'Continue with import',
  'action:submit-services': 'View summary of my request',
  'action:submit-summary': 'Save and/or print label',
  'action:submit-summary-origin-pickup-point': 'Save',
  'action:fix-errors': 'Correct errors',
  'action:choose-direction-from-agenda': 'Choose an address from my calendar',
  'action:new-address': 'Create a new address',
  'action:choose-another-direction-from-list':
    'Choose an address from my calendar',
  'action:select-direction': 'Choose this address',
  'action:select-locality': 'Select a locality',
  'action:file-type': 'File type',
  'action:download-label': 'Download label',
  'action:change-data': 'I want to modify this data',
  'action:add-package': 'Add a new package',
  'action:add-item': 'Add an item',
  'action:remove-item': 'Remove an item',
  'action:shipment-tracking': 'Track shipment',
  'action:execute-action': 'Execute action',
  'action:apply-filters': 'Apply filters',
  'action:clean-filters': 'Clear filters',
  'action:select-and-continue': 'Select and continue',
  'action:download-xlsx': 'Download as XLSX',
  'action:send-me-the-code': 'Send me the code',
  'action:save-my-new-password': 'Save my new password',
  'action:request-a-shipment': 'Request a shipment',
  'action:request-a-shipment-first': 'I want to make my first shipment now',
  'action:back': 'Back',
  'action:see-normative': 'View Terms and Conditions',
  'action:click-text-copied': 'Copied text',
  'action:text-copied': 'Click to copy',
  'action:new-shipping': 'Request another shipment',
  'action:new-shipping-2': 'Request a new shipment',
  'action:download-pdf': 'Download PDF',
  'action:download-app': 'Download App',
  'action:yes-logout': 'Yes, log out',
  'action:back-home': 'Back to Home',
  'action:export-excel': 'Export to Excel',
  'action:change-delivery-point': 'Change pickup location',
  'noun:delivery-point:error': 'Error',
  'action:understood': 'Understood',
  'noun:actionButtons': 'Actions',
  'noun:status': 'Status',
  'noun:agenda': 'My calendar',
  'noun:important': 'Important',
  'action:export-csv': 'Export to CSV',
  'action:remove-contact': 'Delete contact',
  'action:remove-contacts': 'Delete {contacts} contacts',
  'action:export-contact': 'Export contact',
  'action:export-contacts': 'Export contacts',
  'action:duplicate': 'Duplicate',
  'action:delete': 'Remove',

  // Punto de entrega
  'delivery-point:list:no-results':
    'Use the search function to find delivery points.',

  // Generic nouns
  'noun:user': 'User',
  'noun:password': 'Password',
  'noun:reason': 'Reason for inquiry',
  'noun:comments-detail': 'Describe your inquiry',
  'noun:my-new-password': 'My new password',
  'noun:new-password': 'New password',
  'noun:current-password': 'Current password',
  'noun:code': 'Code',
  'noun:route': 'Address',
  'noun:tracking': 'Tracking',
  'noun:recording': 'Shipment file',
  'noun:incidents': 'Incidents',
  'noun:page': 'Page',
  'noun:incidents:lowercase': 'incidents',
  'noun:incidents:lowercase:singular': 'incident',
  'noun:help-support': 'Help and Support',
  'noun:senderAddress2': 'Source',
  'noun:recipientAddress2': 'Destination',
  'noun:destinAddress2': 'Destination',
  'noun:refundValue': 'Refund',
  'noun:shippingTypeCode': 'Product Type',
  'noun:shipment': 'Shipment',
  'noun:shipments': 'Shipments',
  'noun:sender': 'Sender',
  'shipping-detail:sender-data': 'Sender data:',
  'noun:receptor': 'Recipient',
  'noun:inventory': 'Content inventory',
  'noun:normative': 'Declared customs regulations',
  'noun:normative-1': 'Dual-Use Declaration',
  'noun:normative-2': 'CITES Declaration',
  'noun:normative-3': 'Permanent Export',
  'noun:normative-4': 'Waste Declaration',
  'noun:document': 'Document {number}: {serial}',
  'noun:additional-documentation': 'Additional Customs Documentation',
  'noun:shipments:lowercase': 'shipments',
  'noun:shipments:lowercase:singular': 'shipment',
  'noun:shipment-destiny': 'Shipment / Destination',
  'noun:last-status': 'Last status',
  'noun:resume': 'Summary',
  'noun:allocation-center': 'Allocation center',
  'noun:postal-address': 'Postal address',
  'noun:incorrect-address': 'Incorrect address',
  'noun:resolve-incident': 'Resolve incident',
  'noun:add-address': 'Add address',
  'noun:name': 'Name',
  'noun:phonePrefix': 'Pref.',
  'noun:name-company': 'Name / Company',
  'noun:address': 'Address',
  'noun:contact-client-code': 'Regular customer code',
  'noun:recipient-contact': 'Recipient contact',
  'noun:customs-info-title': 'Customs information (optional)',
  'noun:customs-type-label': 'Company / Individual',
  'noun:select-placeholder': 'Select an option',
  'noun:customs-name-company': 'Company name',
  'noun:customs-name-individual': 'Name for documentation',
  'noun:customs-document-company': 'CIF / NIF',
  'noun:customs-document-individual': 'DNI / NIE',
  'noun:customs-name-placeholder-company': 'Enter the company name',
  'noun:customs-name-placeholder-individual': 'Enter the invoice name',
  'noun:customs-document-placeholder-company':
    "Enter the company's CIF or NIF",
  'noun:customs-document-placeholder-individual':
    "Enter the individual's DNI or NIE",
  'noun:country': 'Country',
  'noun:country-code': 'Country code',
  'noun:destination-country': 'Destination country',
  'noun:postal-code': 'ZIP code',
  'noun:problem': 'Problem',
  'noun:request': 'Request',
  'noun:question': 'Question',
  'noun:from-source': 'By source',
  'noun:from-destin': 'By destination',
  'noun:complaints-and-claims': 'Claims and complaints',
  'noun:suggestions': 'Suggestions',
  'noun:deliveryDate': 'Delivery Date',
  'noun:schedule': 'Schedule',
  'noun:commodityType': 'Commodity Type',

  'noun:city': 'City',
  'noun:province': 'Province',
  'noun:phone': 'Phone',
  'noun:mobile-phone': 'Cell phone',
  'noun:mobile-phone-optional': 'Cell phone (Optional)',
  'noun:contact-phone': 'Contact phone',
  'noun:email': 'Email',
  'noun:contact-email': 'Contact email',
  'noun:floor': 'Floor',
  'noun:stair': 'Stair',
  'noun:letter': 'Letter',
  'noun:pick-up-date': 'Pickup date',
  'noun:timetable': 'Schedule',
  'noun:time-slot': 'Time slot',
  'noun:comments': 'Comments',
  'noun:additional-services': 'Additional services',
  'noun:customs': 'Customs',
  'noun:additional-services-title':
    "Are there any additional services you'd like to add?",
  'noun:additional-services-description':
    'We offer the following additional services; please select the ones you need:',
  'noun:pudos-additional-services-title':
    'We’re sorry, but it’s not possible to add any additional services when selecting delivery to a CTT Express Point',
  'noun:additional-services-empty':
    'You have not selected any additional services',
  'noun:weight': 'Weight',
  'noun:length': 'Length',
  'noun:width': 'Width',
  'noun:height': 'Height',
  'noun:yes': 'Yes',
  'noun:no': 'No',
  'noun:type-of': 'Type of {type}',
  'noun:service-type': 'Service type',
  'noun:clientReference': 'Reference',
  'noun:number-of-packages': 'Packages',
  'noun:total-weight-kgs': 'Total weight in kg',
  'noun:last-update': 'Last update',
  'noun:declared-value': 'Declared value',
  'noun:return-value': 'Number of packages',
  'noun:refund': 'Refund',
  'noun:refund-amount': 'Refund amount',
  'noun:refund-description':
    'This service allows you to collect payment for the value of the merchandise upon delivery. Enter the amount the recipient must pay upon receiving their package (up to a maximum of {formattedAmount} €). This service is available exclusively for shipments to Spain or Portugal.',
  'noun:insurance-merchandise': 'Insured merchandise value',
  'noun:additional-coverage': 'Additional Coverage',
  'noun:additional-coverage-description-national':
    'Coverage for loss or theft of the declared value of the contents (up to a maximum of {formattedAmount} €). Enter the declared value of your goods. The cost of this coverage will be 1.50% of the declared value (minimum 2 €).',
  'noun:additional-coverage-description-international':
    'Coverage for loss or theft of the declared value of the contents (up to a maximum of {formattedAmount} €). Enter the declared value of your merchandise. The cost of this coverage will be 1% of the declared value (minimum 10€).',
  'noun:insurance-merchandise-description':
    'Enter the approximate value for which your merchandise is insured.',
  'noun:additional-return':
    'This service allows you to have your goods delivered to the recipient, while also giving you the option to have the recipient hand over other goods to us at that same time for return.',
  'noun:additional-slip-scan':
    'Service for scanning the customer’s delivery slip, signed by the recipient upon delivery.',
  'noun:insurance-value': 'Insurance value',
  'noun:origin-data': 'Origin data',
  'noun:destination-data': 'Destination data',
  'noun:name-surname': 'First and last name',
  'noun:description': 'Description',
  'noun:date': 'Date',
  'noun:selected-timetable': 'Preferred Time',
  'noun:ask-about': "We're asking about",
  'noun:shipment-detail': 'Shipment details',
  'noun:commercial-bill': 'Commercial invoice details',
  'noun:contracted-service': 'Contracted Service',
  'noun:reference': 'Reference',
  'noun:total-packages': 'Packages',
  'noun:total-packages-plural': '{count, plural, one {Package} other {Packages}}',
  'noun:CP-sender': 'CP Sender',
  'noun:CP-destination': 'CP Recipient',
  'noun:CTT-point': 'CTT Express Point',
  'noun:scaned-albaran': 'Scanned Waybill',
  'noun:albaran-pt': 'PT Delivery Note',
  'noun:return': 'Return',
  'noun:return-shipment-number': 'Returned shipment number',
  'noun:declared-price': 'Declared value',
  'noun:dni-verification': 'ID verification',
  'noun:reference2': 'Reference 2',
  'noun:enter-size-and-aprox-weight':
    'Enter the dimensions and approximate weight',
  'noun:appraisal-weight': 'Appraisal weight',
  'noun:reported weight': 'Reported weight',
  'noun:insured-value': 'Insured value',
  'noun:id-verification': 'ID verification',
  'noun:department': 'Department',
  'noun:file_name': 'File name',
  'noun:upload_datetime': 'Upload date',
  'noun:upload_hour': 'Time',
  'noun:success_lines': 'Successful uploads',
  'noun:error_lines': 'Failed uploads',
  'noun:success_lines_agenda': 'Contacts loaded',
  'noun:error_lines_agenda': 'Contacts not loaded',
  'noun:shippingCode': 'Shipping number',
  'noun:shippingDate': 'Date',
  'noun:shippingStatusCode': 'Status',
  'noun:incidentDescription': 'Incident description',
  'noun:clientCenterCode': 'Client Center',

  'noun:reports': 'Reports',
  'noun:report': 'Recipient',
  'noun:download': 'Document',
  'noun:subscription': 'Subscription',
  'noun:type': 'Type',
  'noun:settings': 'Settings',

  'noun:recipientName': 'Recipient',
  'noun:filters': 'Filters',
  'noun:reportConfig': 'Report Subscription',
  'noun:reportList': 'Back to Reports',
  'noun:state-filters': 'Statuses',
  'noun:incident-filters': 'Manageable Incidents',
  'noun:read': 'Read',
  'noun:all': 'All',
  'noun:from': 'From',
  'noun:to': 'To',
  'noun:by-incident-type': 'Manageable Incidents',
  'noun:by-last-status': 'By last status',
  'noun:search-by-date': 'Search by date',
  'noun:any-date': 'Any date',
  'noun:last-month': 'Last month',
  'noun:last-quarter': 'Last quarter',
  'noun:want-search-by-range': 'I want to search by range',
  'noun:date-first-reading': 'Recording date',
  'noun:expected-delivery-date': 'Expected delivery date',
  'noun:tomorrow': 'Tomorrow',
  'noun:not-defined': 'Not defined',
  'noun:edit': 'Edit',
  'noun:cancel': 'Cancel',
  'noun:my-contracts': 'My contracts',
  'noun:billing': 'Billing',
  'noun:invoices': 'invoices',
  'noun:print-settings': 'Print settings',
  'noun:user-zone': 'User Zone',
  'noun:account': 'My Account',
  'noun:go-to-print-settings': 'Go to print settings',
  'noun:invoice-number': 'Invoice number',
  'noun:client-center-code': 'Client Center Code',
  'noun:amount-in-€': 'Amount in €',
  'noun:amount': 'Amount',
  'noun:base-amount': 'Base amount',
  'noun:weight-extra-amount': 'Excess weight/dimensions charge',
  'noun:city-origin': 'City of origin',
  'noun:city-destiny': 'Destination city',
  'noun:last-status-date': 'Date of last status',
  'noun:article:country': 'the country',
  'noun:article:name': 'the name of the establishment',
  'noun:article:postalCode': 'the ZIP code',
  'noun:article:city': 'the city',
  'noun:article:route': 'the street',
  'noun:article:streetNumber': 'the street number',
  'noun:and': 'and',
  'noun:elements-per-page': 'Items per page',
  'noun:shipments-per-page': 'Shipments per page',
  'noun:contacts-per-page': 'Contacts per page',
  'noun:files-per-page': 'Files per page',
  'noun:contacts': 'Contacts',
  'noun:date-and-time': 'Date and time',
  'noun:shipping-item': 'Package',
  'noun:-appraisal-weight': 'Approximate total weight',
  'noun:sure-logout': 'Are you sure you want to log out?',
  'noun:all-your-shippings': 'All your shipments',
  'noun:my-agenda': 'Contact list',
  'noun:imported-register': 'Import register',

  'noun:under-construction': 'Under construction!',
  'noun:under-construction-explanation':
    'We’re working on making it possible for you to view and download your invoices here soon.',
  'noun:shipping-number': 'Shipping number',
  'noun:contact-data': 'Contact information',
  'noun:subject': 'Subject',
  'noun:CLIENTWEB_CI_4': 'Shipping Request',
  'noun:CLIENTWEB_CI_5': 'Tracking',
  'noun:CLIENTWEB_CI_6': 'Incident Management',
  'noun:CLIENTWEB_CI_7': 'Contact list',
  'noun:CLIENTWEB_CI_8': 'Printing',
  'noun:CLIENTWEB_CI_9': 'Settings (Centers, Billing, Address Data)',
  'noun:CLIENTWEB_OTROS': 'Other',
  'noun:CLIENTWEB_IN_1': 'E-commerce Modules',
  'noun:CLIENTWEB_IN_2': 'Mapper',
  'noun:CLIENTWEB_IN_3': 'Integration: ApiRest, Web Service, or Files',
  'noun:CLIENTWEB_ATC_1': 'Shipping Issues',
  'noun:CLIENTWEB_ATC_2': 'Suggestions',
  'noun:CLIENTWEB_ATC_3': 'Complaints',
  'noun:CLIENTWEB_SALES_3': 'Change of Billing Address on the Contract',
  'noun:CLIENTWEB_SALES_4': 'Rates and Costs',
  'noun:CLIENTWEB_SALES_5': 'Update contact information',
  'noun:CLIENTWEB_SALES_6': 'Contact or sales visit',
  'noun:CLIENTWEB_BILL_2': 'Cash-on-delivery shipments',
  'noun:CLIENTWEB_BILL_3': 'Invoices',
  'noun:CLIENTWEB_BILL_4': 'Credits',
  'noun:CLIENTWEB_BILL_5': 'Bank account',
  'noun:other': 'Other',
  'noun:manifest': 'Manifest',
  'noun:download-shippings': 'Advanced filters and download',
  'noun:generation-manifest-date': 'Date:',
  'noun:generation-manifest-shipments': 'Shipment manifest',
  'noun:generation-manifest-packages': 'Total number of packages:',
  'noun:generation-manifest-shippings': 'Total shipments:',
  'noun:generation-manifest-weight': 'Total reported weight:',
  'noun:generation-manifest-return': 'Total refunds:',
  'noun:recipient-date': 'Recipient details',
  'noun:returns': 'Returns',
  'noun:activate-return': 'Request a return',
  'noun:return-number': 'Return shipment number:',
  'noun:unscheduled-pickups': 'Unscheduled Pickups',
  'noun:unscheduled': 'Unscheduled Pickups',
  'noun:maintenance': 'Maintenance',
  'noun:sorry-for-inconveniences': 'We apologize for the inconvenience',
  'noun:shippingWeight': 'Weight (n.)',
  'noun:spanish': 'Spanish',
  'noun:english': 'English',
  'noun:volumetric-weight': 'Reported volumetric weight',

  // Fields
  'field:optional': '{field} <span> | Optional</span>',
  'field:money-suffix': '€',
  'field:packages-suffix':
    '{packages, plural, one {1 package} other {{packages} packages}}',
  'field:first-pickup-option':
    '{minDate, date, full} from {minDate, time, short} to {maxDate, time, short}',

  // Generic messages
  'message:saving': 'Saving...',
  'message:loading': 'Loading...',
  'message:asap': 'Suggested pickup',
  'message:fixedPickup': 'My fixed pickup',
  'message:choose-pickup-with-fixed-pickup':
    'This pickup will be in addition to your fixed pickup.',
  'message:time-slot':
    'If you want us to pick up your shipment on the date and time slot you’ve selected, submit your request within {minutes, plural, =0 {the next minute} one {the next minute} other {the next # minutes} }.',
  'message:no-results': 'There are no shipments to display',
  'message:no-results:shippings':
    'You have no request with this reference. Please check it or try another number.',
  'message:no-results:returns':
    'You have no request with this reference. Please check it or try another number.',
  'message:no-results:incidents':
    'You have no request with this reference. Please check it or try another number.',
  'message:no-results:unscheduled':
    'There are no unscheduled shipments matching your search',
  'message:form-errors-destin:title':
    'You are about to replace the destination',
  'message:form-errors-destin:detail':
    'You have entered details about your shipment, but if you continue, that information will be lost.',
  'message:form-errors:title': 'There are errors in the form',
  'message:form-errors:detail':
    "To move on to another section, you must first correct them or discard the changes you've made.",
  'message:save-changes:title': "Don't want to save your changes?",
  'message:save-changes:detail':
    'If you want to continue without losing them, you must save them now',
  'message:abandon-process:title':
    'You are about to exit the application process',
  'message:abandon-process:detail':
    'If you exit now, all your data will be lost and you’ll have to start the process over.',
  'message:successful-shipment':
    'Your shipment has been successfully recorded!',
  'message:outside-origin':
    'Please note that if this origin is not within your usual service area, this may affect the terms of service.',
  'message:outside-destination-km-10h':
    'Certain locations incur a mileage surcharge for the 10:00 a.m. service.',
  'message:outside-destination-km-10h-mi':
    'View towns with a mileage surcharge',
  'message:choose-day': 'First, choose a pickup date.',
  'message:choose-day-hour': 'Select the day and time for your pickup',
  'message:choose-timeslot': 'Finally, select a time slot.',
  'message:choose-schedule': 'Next, select a time.',
  'message:you-are-going-to-cancel-shipment':
    'You are about to cancel these shipments',
  'message:if-you-cancel-this-shipment-you-cant-recovery':
    "Once you cancel these requests, you won't be able to recover them.",
  'message:duplicate-shipment-title': 'Duplicate this shipment?',
  'message:duplicate-shipment-description':
    "We'll create a new shipment with the same details, weight and dimensions as the original. The original shipment won't be changed.",
  'message:most-sustainable-option': 'Most sustainable option',
  'message:search-by-street-zone-or-postal-code':
    'Search for the ZIP code or address here and select a CTT Express location',
  'message:click-on-confirm-to-continue':
    'Click “Confirm” to continue with the process.',
  'message:pickup-point-contact-data':
    'Once we drop off the package at the CTT Express Pickup Point, we’ll notify your recipient so they can pick it up.',
  'message:unscheduled-date-subtitle':
    'Remember that you can schedule this pickup from the shipment details and in the tracking section.',
  'message:preparing-download': 'Preparing download',

  'pickupPoint:title': 'Pick up directly at a CTT Express location',
  'pickupPoint:subtitle': 'The origin will be selected by the sender',

  // Weekdays
  'weekday:1': 'Monday',
  'weekday:2': 'Tuesday',
  'weekday:3': 'Wednesday',
  'weekday:4': 'Thursday',
  'weekday:5': 'Friday',
  'weekday:6': 'Saturday',
  'weekday:7': 'Sunday',

  // Generic errors
  'error:404:title': "We couldn't find the page you're looking for",
  'error:404:text':
    'We recommend that you return to the home page or use the menu options to continue viewing content while we resolve the issue.',
  'error:server:title': "It looks like we're having a problem",
  'error:server:text':
    'We recommend that you return to the home page or use the menu options to continue viewing content while we resolve the issue.',
  'error:connection:title': 'There seems to be a connection problem',
  'error:connection:text':
    'You may not have an Internet connection, or your connection may be unstable. We recommend that you:',
  'error:internal:title': "It looks like we're having a problem",
  'error:internal:text':
    "We can't display the page you're looking for; there may be a connection issue with the server.",
  'error:contact-with-us': 'If the problem persists, <Link>contact us</Link>.',
  'error:network':
    'It seems there is a connection problem. Please check your internet connection or try again later.',
  'error:limit-exceeded':
    'You have exceeded the maximum number of attempts. Please try again later.',
  'error:code-mismatch': 'Invalid code. Please try again.',
  'error:general':
    'An error occurred during the request. Please try again later.',
  'error:cancel-shipment':
    'An error occurred while canceling the shipments. Please try again.',
  'error:duplicate-shipment':
    'An error occurred while duplicating the shipment. Please try again.',

  // Form errors
  'error:form:request-generic': 'An error occurred while making the request',
  'error:form:debug': 'Error forced for testing purposes',
  'error:form:step':
    'An error occurred in this step. Please modify the data to continue',
  'error:form:search-not-possible':
    'The search could not be performed. Please try again.',
  'error:form:search-not-possible-verify-postal-code':
    'We were unable to identify the ZIP code for this address. Please try to be more specific with the address',
  'error:form:customs':
    'There are required fields that have not been filled out. Please review them before continuing.',

  // Form field errors
  'error:field:required': 'This field is required.',
  'error:field:conditions-required': 'Please accept the fields marked in red:',
  'error:field:phone:required': 'The phone number is required.',
  'error:field:postal-code:required': 'The ZIP code is required.',
  'error:field:customs-name:required': 'This field is required.',
  'error:field:customs-document:required': 'This field is required.',
  'error:field:streetNumber:required': 'The street number is required.',
  'error:field:route:required': 'The street name is required.',
  'error:field:min-length-required': 'The minimum length is 6 characters.',
  'error:field:min-string-length': 'The minimum length is {min} characters.',
  'error:field:max-string-length': 'The maximum length is {max} characters.',
  'error:field:min-array-length': 'You must enter at least one item.',
  'error:field:min-date': 'The minimum date is {min, date, ::yyyyMMdd}.',
  'error:field:min-number': 'The minimum value is {min, number}.',
  'error:field:max-number': 'The maximum value is {max, number}.',
  'error:field:min-monetary-amount':
    'The minimum value is {formattedAmount} €.',
  'error:field:max-monetary-amount':
    'The maximum value is {formattedAmount} €.',
  'error:field:no-zero': 'The value cannot be 0 €.',
  'error:field:email': 'Please enter a valid email address.',
  'error:field:password': 'You must enter a valid password.',
  'error:field:invalid': 'The value is incorrect.',
  'error:field:cp-format': 'The ZIP code is incorrect for the selected country',
  'error:field:package-row:empty-fields': 'Please fill in all required fields.',
  'error:field:address-autocomplete': 'Please add {missingFields} to continue.',
  'error:field:not-found-results-with-postal-code':
    "We couldn't find any results for this ZIP code. Please check to make sure it's correct.",
  'error:shipment-number:length': 'The shipment number must be 22 digits long.',
  'error:shipment-number:not-found': 'The shipment number does not exist.',
  'error:origin-address:invalid-origin':
    'You cannot schedule a pickup at an address outside of Spain or Portugal; please select another address to continue.',
  'error:field:package-row:weight-exceeded':
    'The weight per package you entered exceeds the maximum allowed of {value} kg.',
  'error:field:package-row:measure-exceeded':
    'The height, width, or length exceeds the maximum allowed dimension of {value} cm.',
  'error:field:package-row:height-exceeded':
    'The height exceeds the maximum allowed dimension of {value} cm.',
  'error:field:package-row:width-exceeded':
    'The width exceeds the maximum allowed dimension of {value} cm.',
  'error:field:package-row:length-exceeded':
    'The length exceeds the maximum allowed length of {value} cm.',
  'error:field:package-row:measures-sum-exceeded-pudos':
    'The sum of the height, width, and length cannot exceed {value} cm.',
  'error:field:package-row:measures-sum-exceeded':
    'This origin or destination does not support the reported volumetric weight',
  'error:field:package-row:weight-minimum':
    'The minimum weight per package must be greater than 0 kg.',
  'error:field:package-row:width-minimum':
    'The minimum length per package must be greater than 0 cm.',
  'error:field:package-row:length-minimum':
    'The minimum width per package must be greater than 0 cm.',
  'error:field:package-row:height-minimum':
    'The minimum height per package must be greater than 0 cm.',
  'error:field:max-files': 'The maximum number of files is {maxFiles}.',
  'error:customs:min-value': 'The minimum quantity is 1.',
  'error:customs:max-value': 'The maximum quantity is 9999999.',
  'error:customs-description:max-value':
    'The length cannot exceed 70 characters',
  'error:albaran-not-found':
    'The file is currently unavailable. <p>Please try again later.</p>',
  'error:document-not-available': 'Document not available.',

  // Frontpage
  'frontpage:placeholder': 'Root page placeholder',
  'frontpage:user':
    'Logged in as user {user} on {date, date, full} at {date, time, full}',

  // Login
  'login:title': 'Log in to CTT Express',
  'login:title-mobile': 'Access your personal account',
  'login:error:form:user-not-found':
    'The email address and/or password are incorrect.',
  'login:error:form:user-requires-new-password':
    'Unable to log in with a temporary password. Please contact the administrator to change your password.',
  'login:remember-password': "I don't remember my password",
  'login:recover-password': 'Reset My Password',
  'login:create-account-explanation':
    'If you own a business and don’t yet have a CTT Express account, please provide your information <strong><link>here</link></strong> and we’ll call you. No obligation!',

  // Send Code
  'request-password-reset:explanation':
    'Enter the email address you used to register with CTT Express so we can send you an access code:',
  'request-password-reset:warning:check-spam':
    'If you don’t see our email in your inbox, check your spam folder',

  // Reset Password
  'reset-password:enter-code-and-choose-password':
    'Enter the code we sent you here and choose a password:',
  'reset-password:email-not-received-send-again':
    "I didn't receive the email; please send it again",
  'reset-password:warning:validate-password':
    'Your password must be at least 8 characters long and include at least one uppercase letter and one number.',

  // Shipping Send Form
  'shipping-send-form:title': 'I want to request a shipment',
  'shipping-send-form:new-address:phone-length-error': 'Invalid phone number',
  'shipping-send-form:address:no-phone-error':
    'The selected address is incomplete. You must add a phone number to continue.',
  'shipping-send-form:address:no-phone-email-error-center':
    'The selected center has incomplete information. Please contact your sales representative to complete the details and ensure delivery.',
  'shipping-send-form:new-address:phone-min-length-error':
    'Invalid phone number. It must be at least 6 characters long.',
  'shipping-send-form:new-address:phone-max-length-error':
    'Invalid phone number. It must be 15 characters or fewer.',
  'shipping-send-form:new-address:phone-format-error': 'Incorrect format',
  'shipping-send-form:new-address:phone-format-or-length-error':
    'Incorrect phone number format or length',
  'shipping-send-form:new-address:dni-format-error': 'Incorrect format',
  'shipping-send-form:new-address:phone-digits-error':
    'The number must be 9 digits long',
  'shipping-send-form:new-address:phone-initial-number-error':
    'A cell phone number cannot start with 9',
  'shipping-send-form:new-address:placeholder':
    'Search for your address and the fields will be auto-filled',
  'shipping-send-form:new-address-agenda:placeholder':
    'Search for your address and the fields will be auto-filled',
  'shipping-send-form:origin': 'Pick up at origin:',
  'shipping-send-form:summary:pickup':
    '{weekDay}, {minDate, date, short} from {minDate, time, short} to {maxDate, time, short}.',
  'shipping-send-form:pickup-date':
    'We will pick it up on {minDate, date, ::ddMMyyyy} from {minDate, time, short} to {maxDate, time, short}.',
  'shipping-send-form:fixed-pickup-date':
    'We will pick it up on {fromDate, date, ::ddMMyyyy} from {fromDate, time, short} to {toDate, time, short}.',
  'shipping-send-form:origin:timetable:morning':
    'Morning ({minDate, time, short} to {maxDate, time, short}.)',
  'shipping-send-form:origin:timetable:afternoon':
    'Afternoon ({minDate, time, short} to {maxDate, time, short}.)',
  'shipping-send-form:origin:new-address:address-finder': 'Address Finder',
  'shipping-send-form:origin:new-address:address': 'Address',
  'shipping-send-form:origin:new-address:postal-code': 'ZIP code',
  'shipping-send-form:origin:new-address:postal-code-placeholder': '1234...',
  'shipping-send-form:origin:new-address:postal-code-es-placeholder': '12345',
  'shipping-send-form:origin:new-address:postal-code-pt-placeholder': '1234567',
  'shipping-send-form:origin:new-address:province': 'Province',
  'shipping-send-form:origin:new-address:city': 'City',
  'shipping-send-form:origin:new-address:locality': 'Locality',
  'shipping-send-form:origin:new-address:comments-label':
    'Example: Puxeiros Highway, km 6, Building 1',
  'shipping-send-form:origin:pickup:choose-schedule': 'Choose a time',
  'shipping-send-form:origin:pickup:asap-requirements':
    'To calculate the earliest pickup date, we first need you to provide a mailing address',
  'shipping-send-form:origin:pickup:choose-requirements':
    'Before we can show you the available dates, we need you to provide a mailing address',
  'shipping-send-form:origin:timetable:anytime': 'Any time of day',
  'shipping-send-form:origin:timetable:select-timeslot': 'Choose a time slot',
  'shipping-send-form:origin-mobile': 'Pick up at origin:',
  'shipping-send-form:destination-mobile': 'Deliver to destination:',
  'shipping-send-form:title:center': 'Select your cost center',
  'shipping-send-form:title:origin-address':
    'Where would you like us to pick it up?',
  'shipping-send-form:label:existing-address': 'At one of my addresses',
  'shipping-send-form:label:contract-address': 'Contract address',
  'shipping-send-form:label:other-address': 'Different address',
  'shipping-send-form:label:new-address': 'To a new address',
  'shipping-send-form:label:pick-up-point': 'At a CTT Express Pickup Point',
  'shipping-send-form:label:pick-up-point-collect':
    'At a Pick&Drop Point',
  'shipping-send-form:label:tooltip-autofill-postal-code':
    'This field is automatically filled in when you enter the ZIP code.',
  'shipping-send-form:helper-text:several-localities-associate-with-postal-code':
    'We found several locations associated with the entered postal code; please select the correct one.',
  'shipping-send-form:helper-text:not-found-localities-input-manually':
    'We haven’t found any localities associated with the entered postal code; please fill in the field manually.',
  'shipping-send-form:helper-text:not-found-province-input-manually':
    "We couldn't find any provinces associated with the postal code you entered. Please enter the province manually.",
  'shipping-send-form:contact-details': 'Who are you looking for?',
  'shipping-send-form:title:pick-up-date':
    'When would you like us to pick it up?',
  'shipping-send-form:title:additional-comments':
    'Is there anything our driver needs to know?',
  'shipping-send-form:placeholder:additional-comments':
    'Street, Neighborhood, Building, etc.',
  'shipping-send-form:label:additional-comments':
    'Other relevant address details',
  'shipping-send-form:action:back-from': 'Back to origin',
  'shipping-send-form:action:back-to': 'Back to destination',
  'shipping-send-form:action:back-shipment': 'Back to shipment',
  'shipping-send-form:action:back-services': 'Back to Additional Services',
  'shipping-send-form:action:back-customs': 'Back to customs',
  'shipping-send-form:action:back-summary': 'Back to summary',
  'shipping-send-form:action:back-init': 'Back to Start',
  'shipping-send-form:action:confirm-address': 'Confirm Address',
  'shipping-send-form:action:confirm-data-destination':
    'Confirm destination details',
  'shipping-send-form:action:confirm-data-origin': 'Confirm origin details',
  'shipping-send-form:action:cancel-my-request': 'Cancel my request',
  'shipping-send-form:action:process-shipment': 'Process this shipment',
  'shipping-send-form:action:confirm-cancellation': 'Yes, I want to cancel',
  'shipping-send-form:snackbar-address-saved':
    'Address saved to your address book',
  'shipping-send-form:alert-address-saved':
    'This address has been saved to your address book.',
  'shipping-send-form:alert-address-saved-error':
    'We were unable to save the address to your address book.',
  'shipping-send-form:try-again': 'Try again',
  'shipping-send-form:time-slot-option':
    'from {minDate, time, short} to {maxDate, time, short}',
  'shipping-send-form:error:time-slot':
    'The selected option is no longer available',
  'shipping-send-form:origin:postal-code:invalid-format':
    'Invalid postal code format',

  'shipping-send-form:origin:no-available-hours': 'No dates available',
  'shipping-send-form:origin:select-postal-code': 'First, enter a ZIP code',
  'shipping-send-form:origin:pickup-not-available':
    'We had a problem retrieving the earliest pickup date',
  'shipping-send-form:origin:not-available-dates':
    'We are currently unable to provide a pickup date. Please try again later, and if the error persists, contact the IT Support team.',
  'shipping-send-form:origin:select-poblation':
    'No available dates are shown because you haven’t provided a ZIP code',
  'shipping-send-form:title:destination-address':
    'Please provide the destination address',
  'shipping-send-form:agenda': 'Contact list',
  'shipping-send-form:address-edition': 'Edit address in address book',
  'shipping-send-form:address-edition:success':
    'The address has been successfully updated',
  'shipping-send-form:address:no-address':
    "You don't have any shipping addresses in your address book yet. Add a new address to continue.",
  'shipping-send-form:address-edition:return':
    'Return to the address search tool',
  'shipping-send-form:shipment:service-type': 'Select a service type',
  'shipping-send-form:shipment:custom': 'Customs duties',
  'shipping-send-form:shipment:custom-charge':
    'Select who will be responsible for customs duties:',
  'shipping-send-form:shipment:service-type:info':
    'We only show you the options that best fit your request',
  'shipping-send-form:shipment:reference-number':
    'Would you like to add your own reference number?',
  'shipping-send-form:shipment:commodity-type': 'Commodity Type',
  'shipping-send-form:shipment:select-commodity-type':
    'Select the type of merchandise:',
  'shipping-send-form:shipment:packages': 'Enter the dimensions and weight',
  'shipping-send-form:shipment:packages:content':
    "The more accurate you are with the shipment's weight, the better service we can provide.",
  'shipping-send-form:shipment:information': 'Information about your shipment',
  'shipping-send-form:shipment:need-information':
    "The more accurate you are about the shipment's weight, the better service we can provide:",
  'shipping-send-form:shipment:fill-packages':
    'Fill in the information about the packages in your shipment so you can see which services are the best fit.',
  'shipping-send-form:shipment:wrong-sizes-or-weight':
    'There are no services available for the dimensions and weight you entered.',
  'shipping-send-form:shipment:single-item-warning':
    'This service only allows shipments with a single package.',
  'shipping-send-form:shipment:purchase-sale': 'This is a purchase/sale',
  'shipping-send-form:shipment:between-individuals':
    'This is a standard shipment between individuals',
  'shipping-send-form:shipment:documents': 'Documents',
  'shipping-send-form:shipment:merchandise': 'Merchandise',
  'shipping-send-form:shipment:content-type':
    'What type of content do you want to send?',
  'shipping-send-form:shipment:fill-next-information':
    'Please provide the following information',
  'shipping-send-form:shipment:address-change-detected':
    'Mailing address change detected',
  'shipping-send-form:shipment:origin-address-changed':
    'You have changed the origin of your shipment. You must re-enter the package details and select a new rate.',
  'shipping-send-form:shipment:destin-address-changed':
    'You have changed the destination of your shipment. You must re-enter the package details and select a new rate.',
  'shipping-send-form:shipment:merchandise-info':
    'The more accurate you are with the weight and dimensions of your shipment, the better an estimate we can provide.',
  'shipping-send-form:shipment:merchandise-label': 'Commodity Type',
  'shipping-send-form:shipment:merchandise-placeholder':
    'Electronics, batteries, clothing, alcohol...',
  'shipping-send-form:shipment:document-type': 'Document type',
  'shipping-send-form:shipment:document-description': 'Document description',
  'shipping-send-form:shipment:document-type:personal':
    'Personal document (e.g. a letter)',
  'shipping-send-form:shipment:document-type:internal':
    'Internal company document (e.g. a memorandum)',
  'shipping-send-form:shipment:document-type:commercial':
    'Commercial document (e.g. a contract)',
  'shipping-send-form:shipment:document-type:other': 'Other',
  'shipping-send-form:shipment:custom-value': 'Customs value',
  'shipping-send-form:shipment:limitations':
    'Some shipping types have limitations. Before you provide us with this information, we need to know what type of service you will need.',
  'shipping-send-form:shipment:own-reference-number':
    'If you add your own reference number, it will be easier for you to track your shipment',
  'shipping-send:success:title': 'We have submitted your request',
  'shipping-send:success:description':
    "Don't worry, you don't need to write anything down. You already have a copy in your email",
  'shipping-send:cancel:title': 'You are about to cancel the process',
  'shipping-send:cancel:description':
    'If you cancel your request, you’ll lose all the information you’ve entered',
  'shipping-send-form:shipment:destination-address-label':
    'Destination address',
  'shipping-send-form:keep-in-mind': 'Please note that...',
  'shipping-send-form:sending-documents':
    'You have indicated that your shipment contains documents, <strong>so you do not need any additional documentation for customs.</strong>',
  'shipping-send-form:shipping-restrictions':
    'Please remember that, depending on your shipment’s destination, certain types of goods may be subject to restrictions or special conditions.',
  'shipping-send-form:customs-documentation-text':
    'The destination you’ve selected requires customs documentation. Below, we’ve provided an {invoiceModel}, an {inventorySheet}, and {instructions} on how to fill them out to make the process easier for you (if you have your own documentation template, you may use it). Remember to attach the completed documentation to the outside of your package.',
  'shipping-send-form:invoice-model': 'Customs documentation template',
  'shipping-send-form:instructions': 'instructions',
  'shipping-send-form:inventory-sheet': 'additional inventory sheet',
  'shipping-send-form:download-fill-form':
    "Don't forget to download and fill out the following customs form.",
  'shipping-send-form:download-form': 'Download form',
  'shipping-send-form:accurate-best-service':
    'The more accurate you are, the better service we can provide.',
  'shipping-send-message:schedule-may-change':
    'Schedules may be subject to change due to circumstances beyond our control.',
  'shipping-send-message:request-pickup-later':
    'You can schedule this pickup from the shipment details page and in the tracking section.',
  'shipping-send-message:request-pickup-later-2':
    'We look forward to your instructions so that our delivery drivers can come pick up this shipment.',
  'shipping-send-form:customs:info':
    'The destination/origin you have chosen involves customs procedures, so it is important that you provide the following information so we can prepare the necessary documentation. Please note that we will send this documentation directly to the customs authorities:',
  'shipping-send-form:customs:no-necessary': 'Documentation',
  'shipping-send-form:customs:no-necessary-body':
    'The shipment you are sending does not require any documentation.',
  'shipping-send-form:customs:title':
    'Documentation required for your shipment',
  'shipping-send-form:customs:sender-info': '1. Sender Information',
  'shipping-send-form:customs:receptor-info': '2. Recipient information',
  'shipping-send-form:customs:inventory-custom': '3. Inventory of Contents',
  'shipping-send-form:customs:additional': '4. Additional Documentation',
  'shipping-send-form:customs:legal-acceptance-title': 'LEGAL ACCEPTANCE',
  'shipping-send-form:customs:legal-acceptance-body':
    'Make sure you read and accept the legal terms:',
  'shipping-send-form:customs:authorized':
    'Yes, I have read and declare that the information provided is correct and that the goods I am shipping comply with the',
  'shipping-send-form:customs:custom-normative': 'Customs Regulations.',
  'shipping-send-form:customs:custom-normative-text-1':
    'Shipments made by CTT Express are transported in full compliance with international laws and regulations; therefore, you must accept the information regarding international regulations on the following matters in order to complete your shipment as required by customs authorities.',
  'shipping-send-form:customs:custom-normative-text-declaration':
    'DUAL-USE DECLARATION:',
  'shipping-send-form:customs:custom-normative-text-declaration-body':
    'Certain products/technology (including software) may be intended for both military and nuclear uses; therefore, customs authorities require a declaration stating that the contents you are shipping do NOT have/will not have a military use.',
  'shipping-send-form:customs:custom-normative-text-cities':
    'CITIES DECLARATION:',
  'shipping-send-form:customs:custom-normative-text-cities-body':
    'Customs authorities require that you include with your shipment a declaration stating that the goods you are sending do NOT originate from protected species listed under the CITES agreement for the protection of endangered species of flora and fauna.',
  'shipping-send-form:customs:custom-normative-text-waste':
    'WASTE DECLARATION:',
  'shipping-send-form:customs:custom-normative-text-waste-body':
    'Customs authorities require that you include a declaration with your shipment stating that the goods you are shipping are NOT waste (trash or similar).',
  'shipping-send-form:customs:custom-normative-text-exportacion':
    'PERMANENT EXPORT:',
  'shipping-send-form:customs:custom-normative-text-exportacion-body':
    'CTT Express only handles definitive/permanent exports, which means that the goods leave the customs territory with the intention of remaining permanently outside it.',
  'shipping-send-form:customs:readed':
    'Yes, I authorize the digital signature of my customs declaration.',
  'shipping-send-form:customs:upload-files':
    'Having the correct documentation is key for shipments to the Canary Islands, Ceuta, Melilla, and international destinations to avoid delays or hold-ups and ensure prompt delivery. Here you can attach the necessary documents, such as the Certificate of Origin. Remember that any documentation you attach must not include taxes.',
  'shipping-send-form:customs:inventory-custom-number': 'Item {number}',
  'shipping-send-form:customs:form:type': 'Type',
  'shipping-send-form:customs:form:individual': 'Individual',
  'shipping-send-form:customs:form:dni': 'ID or passport',
  'shipping-send-form:customs:form:reason': 'Reason for shipment',
  'shipping-send-form:customs:form:company': 'Company',
  'shipping-send-form:customs:form:company-name': 'Company Name',
  'shipping-send-form:customs:form:bill': 'Invoice No.',
  'shipping-send-form:customs:form:prosecutor':
    'European Tax ID Number (VAT ID)',
  'shipping-send-form:customs:form:prosecutor-es': 'Tax ID Number (NIF-CIF)',
  'shipping-send-form:customs:form:category': 'Category',
  'shipping-send-form:customs:form:taric_code': 'TARIC code',
  'shipping-send-form:customs:form:taric_code_alert':
    'In this section, you must enter the tariff code (TARIC/Tariff No.), which is an international code used by customs authorities to classify goods. Find your TARIC number by entering the content in English in the "advanced search" section of',
  'shipping-send-form:customs:form:taric_code_alert_link': 'ec.europa.eu.',
  'shipping-send-form:customs:form:place': 'Place of Manufacture',
  'shipping-send-form:customs:form:description':
    'Description of contents (must be in English and all caps)',
  'shipping-send-form:customs:form:description-es':
    'Description of contents (must be in all caps)',
  'shipping-send-form:customs:form:description-summary': 'Description',
  'shipping-send-form:customs:form:quantity': 'Number of items',
  'shipping-send-form:customs:form:price': 'Value per item (excluding VAT)',

  'shipping-send-form:customs:form:select:personal_effects': 'Personal effects',
  'shipping-send-form:customs:form:select:sold': 'Purchase/sale',
  'shipping-send-form:customs:form:select:repair_and_return': 'Return',
  'shipping-send-form:customs:form:select:sample': 'Sample',
  'shipping-send-form:customs:form:select:certificate_of_origin':
    'Certificate of Origin',
  'shipping-send-form:customs:form:select:other': 'Other',
  'shipping-send-form:customs:article-number-format-error':
    'Decimals are not allowed',

  'shipping-send-form:customs:taric-code-empty': 'This field is required',
  'shipping-send-message:weight-1':
    'Maximum weight per package: 40 kg / Maximum dimensions per package: 240 cm (length + width + height) or with no single dimension exceeding 150 cm.',
  'shipping-send-message:weight-2':
    'Maximum weight: 20 kg. Maximum dimensions per package: 240 cm (length + width + height) or with no single dimension exceeding 150 cm.',
  'shipping-send-message:weight-3':
    'Maximum weight: 5 kg. Maximum dimensions per package: 240 cm (length + width + height) or no single dimension exceeding 150 cm.',
  'shipping-send-message:weight-4':
    'Maximum weight per package: 30 kg / Maximum dimensions per package: 40 cm x 30 cm x 30 cm.',
  'shipping-send-message:weight-5':
    'Maximum weight per package: 10 kg / Maximum dimensions per package: 50 cm x 50 cm x 50 cm.',
  'shipping-send-form:origin-pudo:info-1':
    'If you’d like to see the list of pickup locations, click on',
  'shipping-send-form:origin-pudo:available-points-link': 'this link',
  'shipping-send-form:origin-pudo:info-2':
    'It must meet the following requirements:',
  'shipping-send-form:origin-pudo:max-weight': 'Maximum 20 kg',
  'shipping-send-form:origin-pudo:mono-package': 'Single-package shipments',
  'shipping-send-form:origin-pudo:max-dimensions': 'Max. 160 cm (60x40x60)',
  'shipping-send-form:origin-pudo:email-instruction-1_pt':
    'To drop off the package,',
  'shipping-send-form:origin-pudo:email-instruction-bold_pt':
    'the sender must attach the shipping label that will be generated upon completion of this shipment’s registration',
  'shipping-send-form:origin-pudo:email-instruction-2_pt':
    'to any of the authorized drop-off locations.',
  'shipping-send-form:origin-pudo:email-instruction-1':
    'We will send this person the',
  'shipping-send-form:origin-pudo:email-instruction-bold':
    'barcode that they will need to show',
  'shipping-send-form:origin-pudo:email-instruction-2':
    'to deliver the merchandise to',
  'shipping-send-form:origin-pudo:email-instruction-bold-2':
    'any of the authorized locations',
  'shipping-send-form:origin-pudo:email-instruction-3':
    'without having to select one in advance.',
  'shipping-send-form:origin-pudo:sender-info':
    'Who will drop off the merchandise?',
  'shipping-send-form:origin-pudo:sender-country': 'Select the pickup country',
  'shipping-send-form:origin-pudo:sender-country-spain': 'Spain',
  'shipping-send-form:origin-pudo:sender-country-portugal': 'Portugal',
  'shipping-send-form:origin-pudo:alert':
    'Packages must meet the following requirements: Single package only. Max. 20 kg. Max. 160 cm (60x40x50)',
  'shipping-send-form:origin-pudo:alert-pt':
    'Note: In the Azores, the maximum weight is 5 kg.',
  'shipping-send-form:one-package-alert':
    'Pickups at CTT Express locations are limited to a single package.',
  'shipping-send-form:label-packages':
    'Remember that it is mandatory to label the packages.',
  'shipping-send-form:fixed-pickup-extra-cost':
    'You have a scheduled pickup on {dayMonth} from {minHour} a.m. to {maxHour} a.m. Please note that this request may incur an additional fee.',
  'shipping-send-form:service-price':
    '(*) Rate based on the weights and dimensions provided.',
  'shipping-send-form:summary-service-price':
    '(*) Estimated rate based on the declared weights and dimensions, subject to change according to your contractual terms.',
  'shipping-send-form:reference-format-error':
    'The reference may only contain letters, numbers, hyphens, and underscores',
  'shipping-send-form:format-error': 'Incorrect format',
  'shipping-send-form:only-number-error': 'This field only accepts numbers.',
  'shipping-send:stored-info': 'The shipment is ready for delivery or return.',
  // Send summary'
  'shipping-send-summary:legal':
    '<p>Make sure all your shipment details are correct. CTT Express reserves the right not to pick up or deliver the package if the dimensions and/or weight of your shipment differ significantly from those provided in your shipment details.</p> <p>Please also note that schedules may be subject to change due to circumstances beyond our control.</p>',

  // Send success
  'shipping-send-success:shipping-code': 'Shipping code:',
  'shipping-send-success:shipping-number': 'Shipping number:',
  'shipping-send-success:helper-text':
    'Remember that at <strong>Shipment Tracking</strong>, you can view all your recorded shipments and their statuses, as well as print their labels whenever you want.',
  'shipping-send-success:helper-text-2':
    'You can now print or download the shipping label.',
  'shipping-send-success:helper-text-origin-pudo':
    'Remember that at <strong>Shipment Tracking</strong>, you can view all your recorded shipments and their statuses, as well as print their labels whenever you want.',
  'shipping-send-success:helper-text-mobile':
    'If you’d like to check it later, we’ve sent you an email with the shipment details.',

  // Cancel shipping
  'shipping-send-cancel:alert-description':
    'Remember that you can only cancel shipments with a status of “Saved.”',

  // Cancel manifest
  'generate-manifest-cancel:alert-description':
    'The manifest is only available for shipments with a origin and destination at the billing address or another residential address.',

  // Addresses
  'address:without-name': '{address}, {postalCode}, {city}, {country}',
  'address:contract-default': 'Associated with the contract',
  'address:address-book': 'Associated with your address book',

  // Helpers
  'helper:origin': "Where you're sending it from",
  'helper:destination': "Who you're sending it to",
  'helper:shipment': 'Tell us about the goods',
  'helper:customs': 'Customs documentation',
  'helper:additional-services': 'How will the delivery be handled?',
  'helper:resume': 'Check your request',
  'helper:max-amount': 'Maximum {formattedAmount} €',
  'helper:max-un': 'Maximum {formattedAmount} un.',

  // Placeholders
  'placeholder:client': 'Type or select from the list',
  'placeholder:postal-code': '00000 | -',
  'placeholder:max-characters': 'Maximum {number} characters...',
  'placeholder:date': 'dd/mm/yyyy',
  'placeholder:kilograms': '{number} kg', // TODO: rename
  'placeholder:centimetres': '{number} cm', // TODO: rename
  'placeholder:service-type': 'Choose a service',
  'placeholder:phone': '+34 000 000 000',
  'placeholder:search-by-name-or-address': 'Search by name or address',
  'placeholder:search-by-name-or-address-or-code':
    'Search by name, address, or regular customer code',
  'placeholder:search-by-name-or-address-or-company':
    'Search by name or address',
  'placeholder:select-country': 'Select a country',

  // Tooltips
  'tooltip:locality':
    'Change the city name if you believe the entered ZIP code also corresponds to another municipality.',
  'tooltip:go-tracking': 'Go to shipment tracking',
  'tooltip:delete-file': 'Remove file from the list',
  'tooltip:success-files': 'Total shipments successfully recorded',
  'tooltip:errored-files': 'Total uploads NOT saved',
  'tooltip:download-CSV': 'File containing submissions that failed to upload',
  'tooltip:processing-request': 'Processing request',
  'tooltip:return-shipment': 'View return shipment',
  'tooltip:schedule': 'Schedule a pickup for this item',
  'tooltip:not-schedule':
    'The shipment cannot be scheduled. Center is inactive',
  'tooltip:not-resoluble': 'You CANNOT resolve this issue through this website',
  'tooltip:resoluble': 'You can resolve this issue through this website',
  'tooltip:solved':
    'This issue has already been resolved and is pending implementation',
  'tooltip:regular-addresses': 'Here is a list of your regular addresses.',
  'tooltip:return-email':
    'The sender will receive an email notification allowing them to choose the pickup date and/or address, and even select a CTT Express location to drop off the package.',
  'tooltip:measures-price':
    'Enter the weight and dimensions to calculate your shipping rate',
  'tooltip:weigth-price': 'Enter the weight to find out your shipping rate',
  'tooltip:new-direction':
    "Use this option if you want to ship to an address that isn't on your list.",
  'tooltip:countries-origin':
    'The origin countries for a shipment are Spain, Andorra, and Portugal',
  'tooltip:service-type':
    'We’ll show you the services you can sign up for based on your origin and destination information',
  'tooltip:reference-number':
    'If you enter your usual reference number, you can easily search for and find your shipment in the tracking list.',
  'tooltip:purchase-sale':
    'We define a purchase/sale as a shipment of goods for which the recipient has made a payment to receive the goods. This does not apply to the purchase/sale of secondhand items between individuals.',
  'tooltip:custom:nif':
    'Please note that if the sender and/or recipient is a business, you must include their tax ID (NIF-IVA) numbers. Check with the Tax Agency to find out how to request them.',
  'tooltip:custom:reason':
    'Indicate the reason for your shipment. Be completely transparent about the purpose of your shipment. Otherwise, you may encounter unnecessary delays. Remember that CTT Express only handles definitive/permanent exports—that is, goods leaving customs territory with the intention of remaining permanently outside it.',
  'tooltip:custom:description':
    'Remember to include a description in English—in all capital letters—for each item you’ve included in your shipment (if you need help with English, you can use Google Translate). The description should explain what the item is, what material it is made of, and what it is used for (if applicable). For example, if you’re shipping new blue leather women’s sneakers, you can enter: “WOMEN’S TENNIS SHOES / BLUE / BOVINE LEATHER / NEW”',
  'tooltip:custom:description-es':
    'The description should explain what the item is, what material it’s made of, and what it’s used for (if applicable). For example, if you’re shipping new blue leather women’s sneakers, you can enter: “WOMEN’S SNEAKERS / BLUE / LEATHER / NEW”',
  'tooltip:custom:quantity':
    'When entering the number of items, if they are all exactly the same product, you only need to enter it once (for example, if you’re sending 2 identical cotton T-shirts, you only need to add it once by entering a 2 in the “No. of Items” field).',
  'tooltip:custom:price':
    'All products must have a value; even if the item is a return, a sample, or a gift, it must still be valued at least at the cost of production (you cannot enter a value of 0€ for an item you’re shipping). Enter the actual value of each item to prevent Customs from requesting additional information, which could cause delays. If you manufactured the item you’re shipping yourself, you can enter the total value as the sum of the material costs and the production cost.',
  'tooltip:custom:place':
    'Include the country of manufacture for the product. If you did not manufacture the product yourself, you can find information about the country of manufacture in the manufacturer’s documentation or on the label marked “Hecho en…” / “Made in”',
  'tooltip:mobile-phone':
    'Only mobile phone numbers will receive notifications',
  // Alerts
  // Alerts
  'alert:document':
    'We define a “document” as any paper-based shipment weighing less than 10 kg. Everything else will be considered “merchandise.”',
  'alert:merchandise':
    'Please note that, depending on your shipment’s destination, <strong>certain types of merchandise may be subject to restrictions or special conditions</strong>. If, due to legal restrictions, we are unable to ship your merchandise, we will contact you as soon as possible.',
  'alert:no-products':
    'There are no products available for the selected origin and destination. Please check with your contact person',
  'alert:environment-error':
    'We are configuring your website; please try again later',
  'alert:go-to-download-page': 'Go to the download page',
  'alert:shippings-search:no-shippings':
    "You don't have any requests with that reference number. Please check it or try another number.",

  // Service types
  'service-type:24h': '24 hours',
  'service-type:weekend': 'Weekend',

  // Other services
  'service:with-return': 'Shipping with return',
  'service:with-handling': 'With handling',
  'service:scan-client-slip': 'Scan customer delivery slip',
  'service:verify-code': 'QR code verification, Bidi...',
  'service:rdp-send': 'Pick up directly at a CTT Express location',

  // Download filenames
  'shipping-send:label:filename': 'ctt-label-{id}.pdf',

  'shipping:extension-error':
    'This file is not in a valid format. Please note that the accepted formats are .DOC, .DOCX, .XLS, .XLSX, .TXT, .RTF, .JPG, .GIF, .BMP, .TIF, .PNG, or .PDF',
  'shipping:size-error':
    'This file is too large. Please try to reduce its size or select a smaller file. Remember that you can upload files up to 5 Mb.',
  'shipping:upload-error':
    'An error occurred during the import process. Please refresh the page, import your file again, or try again later.',
  'shipping:name-error':
    'This file exceeds the maximum allowed length of 244 characters for the file name.',

  //Agenda
  'agenda:title': 'Contact list',
  'agenda:description':
    'Here you can manage your contacts or import them in bulk via a file.',
  'agenda:import-contacts': 'Import contacts',
  'agenda:add-contact': 'Add Contact',
  'agenda:edit-contact': 'Edit contact',
  'agenda:select-center': 'View calendar for:',
  'agenda:empty-state': "You don't have any contacts in this address book yet",
  'agenda:add-success': 'The contact has been added successfully.',
  'agenda:add-error':
    'We were unable to add the contact. Please try again later.',
  'agenda:edit-success': 'The contact has been successfully updated.',
  'agenda:edit-error':
    'We were unable to edit the contact. Please try again later.',
  'agenda:delete-file-success': 'The file has been successfully deleted.',
  'agenda:delete-file-error':
    'We were unable to delete this file; please try again later.',
  'agenda:delete-file': 'Do you want to delete this file?',
  'agenda:delete-file-body1':
    'By clicking "Confirm," you will only delete the file from the import log. The imported contacts will remain saved in the address book.',
  'agenda:delete-file-body2':
    'If you want to delete a contact, you must do so from the {myAgenda} tab',
  'agenda:import-description':
    'Add contacts to your address book in bulk by importing a file in three simple steps.',
  'agenda:how-import': 'How to import?',
  'agenda:step-1': 'Select a location',
  'agenda:step-2-1': 'Download our reference {csv}',
  'agenda:step-2-2': 'template',
  'agenda:step-3': 'Enter the contacts into the template',
  'agenda:step-2-3': 'To avoid errors, we recommend using this template',
  'agenda:step-4': 'Import or drag the template',
  'agenda:info': 'For more information, download our tutorial',
  'agenda:succesfull-title': 'The upload request is being processed',
  'agenda:succesfull-body':
    'We are verifying the file. We will show you the contacts that were uploaded successfully, and for those that were not, we will indicate the type of error.',
  'agenda:succesfull-next-page': 'Next page',
  'agenda:massive-request': 'Generate a new contact import',
  'agenda:save-time': 'and save time when adding contacts.',
  'agenda:import-your-file': 'Import your file',
  'agenda:center-to-import':
    'Select the center to which we will add the contacts',
  'agenda:center-error':
    'You must select a center to which to add the contacts.',
  'agenda:extension-error':
    'This file is not in a valid format. Remember that the accepted format is .xlsx.',
  'agenda:format-error': 'The imported file is in the wrong format.',

  //Shipping Recording
  'shipping-recording:title': 'Bulk Import of Shipments',
  'shipping-recording:import-file': 'File import',
  'shipping-recording:importation-progress': 'Shipment import in progress',
  'shipping-recording:select-method':
    'Select one of these methods to upload your shipments',
  'shipping-recording:select-multiple-centers-1':
    'Multi-center: a single file for all centers',
  'shipping-recording:select-multiple-centers-2':
    'You must include the center code associated with each shipment in the file.',
  'shipping-recording:select-one-center-1':
    'By center: a separate file for each center',
  'shipping-recording:select-one-center-2':
    'You must select the center to associate with the file you attach.',
  'shipping-recording:description':
    'Submit bulk shipping requests to Spain and Portugal by importing a file.',
  'shipping-recording:massive-request': 'Generate a new bulk request',
  'shipping-recording:import-your-file': 'Import your file',
  'shipping-recording:save-time':
    'and save time when processing your shipping requests.',
  'shipping-recording:how-import': 'How to import?',
  'shipping-recording:step-1-1': 'Download {csv}.',
  'shipping-recording:step-1-2': 'this file',
  'shipping-recording:step-2': 'Fill in your shipping information',
  'shipping-recording:step-2-alter':
    'Complete the file by including the Allocation Center for each shipment.',
  'shipping-recording:step-3-alter': 'Upload the file',
  'shipping-recording:step-3': 'Select the cost center and upload the file.',
  'shipping-recording:step-3-1':
    'Remember to include shipments from only one center per file.',
  'shipping-recording:step-3-1-alter':
    'Each shipment will be assigned to the center listed in the “Center Customer” column.',
  'shipping-recording:info': 'For more information, download {tutorial}.',
  'shipping-recording:tutorial': 'our tutorial',
  'shipping-recording:select-center': 'Select the cost center',
  'shipping-recording:delete-file-success':
    'The file has been successfully deleted.',
  'shipping-recording:delete-file-error':
    'We were unable to delete this file; please try again later.',
  'shipping-recording:center-error':
    'You must select a center to which to allocate the shipments.',
  'shipping-recording:delete-file': 'Do you want to delete this file?',
  'shipping-recording:delete-file-body1':
    'Remember that you are only removing the file from this list; this does not affect the shipments.',
  'shipping-recording:delete-file-body2':
    'Your successfully submitted shipments will not be affected. If you wish to cancel a shipment that you uploaded using this file, go to the {shippingTracking} section',
  'shipping-recording:succesfull-title':
    'The upload request was successfully received!',
  'shipping-recording:succesfull-body':
    'We are processing the contents of your file. You can check the status of this process below.',
  'shipping-recording:succesfull-alert':
    '<p> We will pick up your shipment on the first available date. </p> <p> Please note that if you have a scheduled pickup, we will pick up your shipment at the usual time and address. </p>',
  'shipping-recording-schedule-2':
    'We will pick up the goods at the next available time slot for each origin address provided.',
  'shipping-recording-schedule-1':
    'The date and time will be calculated based on the ZIP code and the pickup schedule.',
  'shipping-recording:asap-warning':
    'For each shipment, the earliest possible date and time will be calculated, taking into account the ZIP code and the pickup schedule.',
  'shipping-recording:asap-warning-2':
    'Please note that the earliest the delivery driver can pick up the shipment is 1 hour after the request has been processed.',
  'shipping-recording:asap-info':
    'To find out the exact pickup date for each shipment, go to the Shipment Tracking section once your request has been processed.',
  'shipping-recording:later-warning':
    'Remember that you can schedule this pickup from the shipment details page and in the tracking section. We’ll be waiting for your instructions so our couriers can come pick up this shipment.',
  'shipping-recording:later-info':
    'To find out the exact pickup date for each shipment, go to the Shipment Tracking section once your request has been processed.',
  'shipping-recording:choose-info':
    'To find out the exact pickup date for each shipment, go to the Shipment Tracking section once your request has been processed.',
  'shipping-recording:extension-error':
    'This file is not in a valid format. Please note that the accepted formats are .csv, xls, or xlsx.',
  'shipping-recording:size-error':
    'This file is too large. Please try to reduce its size or select a smaller file. Remember that you can upload files up to 5 Mb.',
  'shipping-recording:upload-error':
    'An error occurred during the import process. Please refresh the page, import your file again, or try again later.',
  'shipping-recording:line-error':
    'The file exceeds the allowed number of shipments. Make sure the document contains no more than 500 shipments.',
  'shipping-recording:pickup-date':
    'We will pick it up on {date} from {minHour} to {maxHour} hrs.',
  'shipping-recording:size-text': 'Maximum of 500 shipments per file.',
  //Reports
  'reports:title': 'Reports',
  'reports:description':
    'Subscribe to receive daily reports on your shipments.',
  'reports:description-2':
    'You can download the reports for free, either from this section or via SFTP using the credentials we’ll send you by email',
  'reports:confirm-sub-title': 'Confirm the activation of this subscription',
  'reports:confirm-unsub-title': 'Would you like to cancel this subscription?',
  'reports:confirm-sub-description':
    "You'll receive daily reports that you can view in the report list.",
  'reports:confirm-unsub-description':
    'If you continue, you will stop receiving these reports and will no longer be able to access the reports you received previously. Remember that you can reactivate it at any time.',
  'reports:config-report': 'Frequency Settings',
  'reports:frequency': 'Frequency',
  'reports:day': 'Day',
  'reports:days': 'Days',
  'reports:week': 'Week',
  'reports:daily': 'Daily',
  'reports:weekly': 'Weekly',
  'reports:month': 'Monthly',
  'reports:hour': 'Time',

  // Shipping Tracking
  'shipping-tracking:shipping-selected':
    'You have selected a total of {shippingCount, plural, one {{shippingCount} shipment} other {{shippingCount} shipments}}. {text}',
  'shipping-tracking:shipping-selected-2':
    'Use the filters to make another selection.',
  'shipping-tracking:shipping-selected-3':
    'Select all shipments with this filter.',
  'shipping-tracking:title': 'Shipment Tracking',
  'shipping-tracking:description':
    'In this list, you can track the status of all your shipments.',
  'shipping-tracking:find-shipments':
    'Set the filter to view or download your shipments',
  'shipping-tracking:by-shipment': 'By shipment',
  'shipping-tracking:search-in-the-incidents': 'Search in incidents',
  'shipping-tracking:show-incidents': 'Show only shipments with incidents',
  'shipping-tracking:current-status':
    'This is the current status of your shipment',
  'shipping-tracking:tracking': 'Tracking',
  'shipping-tracking:shipment-step-by-step': 'Your shipment step by step',
  'shipping-tracking:see-complete-tracking': 'View complete tracking',
  'shipping-tracking:support-link': 'Need help with this shipment?',
  'shipping-tracking:pickup:success:title':
    'Your shipment will arrive on the scheduled date',
  'shipping-tracking:returned:title':
    'Your shipment has been returned to the point of origin and will arrive on',
  'shipping-tracking:pickup:not-defined': 'Not defined',
  'shipping-tracking:pickup:no-delivery-date:subtitle':
    'We’ll be able to provide you with an estimated delivery date as soon as we pick up your order.',
  'shipping-tracking:pickup:error:subtitle':
    'We’re sorry—your shipment may take longer than expected',
  'shipping-tracking:send:success:title':
    'The shipment has been successfully delivered',
  'shipping-tracking:send:no-delivery-date:title':
    'There is no scheduled pickup date yet.',
  'shipping-tracking:send:inactive:title': 'The center is currently inactive.',
  'shipping-tracking:send:inactive:subtitle':
    'The shipment cannot be scheduled because the facility is inactive.',
  'shipping-tracking:send:stored': 'The shipment is {eventName}',
  'shipping-tracking-chip:service-type': 'Service type',
  'shipping-tracking-chip:postal-code': 'ZIP code',
  'shipping-tracking-chip:origin-postal-code': 'Origin ZIP code',
  'shipping-tracking-chip:destin-postal-code': 'Destination ZIP code',
  'shipping-tracking-chip:center-code': 'Customer center code',
  'shipping-tracking-chip:country': 'Country',
  'shipping-tracking-chip:shipping-code-or-reference':
    'Shipping number or reference',
  'shipping-tracking:cancelled:title': 'Your shipment was canceled on:',
  'shipping-tracking:cancelled:subtitle':
    '{datetime, date, ::ddMMyyyy} | {datetime, date, ::kkmm}',
  'shipping-tracking:check-pickup-address':
    'Check the pickup address for your shipment.',
  'shipping-tracking:if-insert-address-is-not-correct-create-new-shipping':
    'If the address you entered is incorrect, you must create a new shipment.',
  'shipping-tracking:if-address-is-correct-contact-customer-support':
    'If the address is correct, contact customer support to resolve this issue.',
  'shipping-tracking:already-resolved':
    'Action has already been taken on this issue, and your shipment is on its way; the new status will be displayed shortly.',
  'shipping-tracking:error-file':
    'No shipments were found for the selected filter.',
  'shipping-tracking:error-date':
    'You cannot download a range longer than 31 days',
  'shipping-tracking:error-unexpected':
    'An unexpected error has occurred. Please try again later',
  'shipping-tracking:error-date-range':
    'A range longer than 7 days cannot be displayed',
  'shipping-tracking:error-date-range-31':
    'A range longer than 31 days cannot be displayed',

  // Tracking
  'tracking:incorrect_address': 'Incomplete/incorrect address',
  'tracking:no_answer': 'Recipient is not answering',
  'tracking:no_answer_r': 'Sender does not answer',
  'tracking:refuses': 'Refused',
  'tracking:no_effective': 'No cash on delivery',
  'tracking:pending': 'Pending entry into the network',
  'tracking:recorded': 'Recorded',
  'tracking:collected': 'Collected',
  'tracking:merchandise-origin': 'Merchandise at the origin branch',
  'tracking:merchandise-destination': 'Merchandise at the destination branch',
  'tracking:in-transit': 'In transit',
  'tracking:available': 'Available for pickup',
  'tracking:distribution': 'Being delivered',
  'tracking:stored': 'Stored',
  'tracking:manifested': 'Manifested',
  'tracking:pudo': 'Available at Punto Pick&Drop',
  'tracking:delivered': 'Delivered',
  'tracking:returned': 'Returned',
  'tracking:depositPending': 'Pending drop-off at Punto Pick&Drop',
  'tracking:deposited': 'Deposited at Punto Pick&Drop',
  'tracking:delivered-plural': 'Delivered',
  'tracking:cancelled': 'Canceled',
  'tracking-line:shipping-cancelled': 'Shipping Canceled',
  'tracking-line:shipping-unscheduled': 'Unscheduled',
  'separator:pudo': 'Pickup at CTT Location',
  'tracking-line:pickup-unscheduled': 'Unscheduled pickup',
  'tracking-line:shipped': 'Shipped',
  'tracking-table:information': 'Information',
  'tracking-table:info:atc': 'Change made by the Customer Service team',
  'tracking-table:info:client-web': 'Change made from the customer private area',
  'tracking-table:info:recipient': 'Change made by the recipient',
  'date-digest:title:expected-delivery-date': 'Expected delivery date',
  'date-digest:title:delivered-date': 'Delivery Date',
  'date-digest:title:cancellation-date': 'Shipment cancellation date',
  'date-digest:body:not-defined-date': 'Not defined.',
  'date-digest:body:unscheduled-date':
    'There is no scheduled pickup date yet. We’ll be able to give you an estimated delivery date as soon as we pick up your order.',
  'date-digest:body:inactive':
    'The shipment cannot be scheduled because the facility is inactive.',
  'date-digest:body:delivery-date':
    '{isTomorrow, select, true {Tomorrow, } other {} }{weekDay} <strong>{date, date, ::ddMMyyyy}</strong>',
  'date-digest:body:cancellation-date':
    '<strong>{datetime, date, ::ddMMyyyy}</strong> {datetime, date, ::kkmmss}',
  'date-digest:footer:not-recoverable-warning':
    'Canceled shipments cannot be recovered',

  // Detail
  'shipping-detail:title': 'Shipment Details',
  'shipping-detail:shipment-number': 'Shipment Number:',
  'shipping-detail:return-number': 'Return Shipment Number:',

  'shipping-detail:original-number': 'Original shipment number:',
  'shipping-detail:pt': 'Portuguese shipping number:',
  'shipping-detail:see-return': 'See Return',
  'shipping-detail:ctt-express-point': 'CTT Express Point',
  'shipping-detail:delivery-location': 'Delivery location',
  'shipping-detail:delivery-location-description':
    'Below you can find the exact delivery location for your shipment.',
  'shipping-detail:delivery-date': 'Delivery Date',
  'shipping-detail:delivery-address': 'Delivery Address',
  'shipping-detail:view-delivery-location': 'View delivery location',
  'shipping-detail:delivery-location-unavailable':
    'The delivery location is not accessible',
  'shipping-detail:delivery-location-reason:locker':
    'The shipment was delivered to a Locker',
  'shipping-detail:delivery-location-reason:pudo':
    'The shipment was delivered to a Pick&Drop point',
  'shipping-detail:delivery-location-reason:lobby':
    'The shipment was delivered at the concierge',
  'shipping-detail:delivery-location-reason:neighbor':
    'The shipment was delivered to a neighbour according to the given instructions.',
  'shipping-detail:additional-info': 'Additional information:',

  // Home
  'home:title': 'Home',
  'home:welcome': '{name, select, unnamed {Welcome} other {Welcome, {name}} }',
  'home:your-activity': 'Here is your activity for the past month.',
  'home:your-activity-s': 'Here is your activity for the past week.',
  'home:shipment-status': 'Shipment Status',
  'home:shipment-locator': 'Shipment Tracker',
  'home:shipment-locator-subtitle':
    'Up-to-date information on all your shipments.',
  'home:find-shipment': "Find the shipment you're looking for",
  'home:result-shipment': 'Search results',
  'home:shipment-search-results': 'Here are your search results',
  'home:shipment-locator-input-helper':
    'You can search using a full or partial tracking or reference number.',
  'home:shipment-locator-input-helper-mobile': 'You must enter the full number',
  'home:shipment-locator-input-placeholder':
    'Shipment number or reference number',
  'home:shipment-recording-input-placeholder': 'File name',
  'home:filters': 'Filter {type} by',
  'home:filters:delete': 'Delete all filters',
  'home:latest-incidents': 'Latest Incidents',
  'home:latest-shipments': 'Latest Shipments',
  'home:no-results':
    "You don't have any requests with that number. Please check it or try another number.",
  'home:view-complete-list': 'View complete list of shipments',
  'home:total-shipments': 'Total shipments',
  'home:promo-banner-line1-start': 'Recipients can now pay',
  'home:promo-banner-line2': 'the refund with a contactless card',

  // Billing
  'billing:title': 'Billing',
  'billing:subtitle':
    'Here you can view your current plan. If you have any questions about your plan, products, and/or services, your sales representative will be happy to assist you.',
  'billing:filter-client-center': 'By Client Center Code',
  'billing:see-my-rate-2023': 'View my 2023 rate',
  'billing:see-my-rate-2024': 'View my 2024 rate',
  'billing:see-my-rate-2025': 'View my 2025 rate',
  'billing:see-my-rate-2026': 'View my 2026 rate',
  'billing:apply-from': 'Effective 01/01/26',
  'billing:select-bill': 'Select rate...',
  'billing:select-invoice': 'Select rate',
  'billing:see-invoices': 'Here you can view your rates',
  'billing:see-rates': 'Rate plans by commitment',
  'billing:no-rates-available': 'No rates are available for the selected year.',

  //Reports
  'reports:empty-reports': 'No reports are available',
  'reports:empty-reports-description':
    'Configure the reports you want to subscribe to.',
  'reports:empty-reports-tooltip':
    'Subscriptions are another feature of your Customer Area that allows us to automatically and periodically deliver large volumes of data to you.',
  'reports:config': 'Report Subscription',

  // Empty states
  'empty:no-shipment-request': 'You have no shipment requests',
  'empty:no-incident-shipments':
    'You have no incidents related to your shipments',
  'empty:want-first-shipment': 'I want to make my first shipment now',
  'empty:no-shippings-title': 'There are no shipments to display',
  'empty:no-results': 'There are no shipments to display',
  'empty:no-results-address-book': 'No addresses found',
  'empty:no-results-search':
    'You have no request with this reference. Please check it or try another number.',
  'empty:no-shippings': "You haven't made any shipments yet",
  'empty:no-incidents': 'You have no incidents related to your shipments',
  'empty:no-returns-title': 'There are no returns to display',
  'empty:no-returns-subtitle': 'No returns have been made yet',
  'empty:no-unscheduled-subtitle':
    'All your shipments have a scheduled pickup date.',
  'empty:try-another-search':
    'You can try another search or return to the list.',
  'empty:try-another-search-address-book':
    'Check the entered data or create a new address.',
  'empty:back-to-list': 'Back to the full list',
  'empty:everything-goes-smoothly': 'Everything is going smoothly!',
  'empty:no-invoices': "We couldn't find any invoices with the applied filters",
  'empty:no-centers': 'Account temporarily inactive',
  'empty:no-centers-body':
    'Your account is temporarily inactive. To resolve this and reactivate your account, please contact your revenue manager.',

  // Session
  'session:about-to-expire': 'Your session is about to expire',
  'session:protect-data':
    'To protect your data, if we don’t detect any activity on your screen, we’ll log you out after the specified time.',
  'session:if-session-closed': 'If the session is closed,',
  'session:you-will-lose-data': 'you will lose your request data',
  'session:continue': 'Continue with this session open',
  'session:make-sure-completed-request':
    'Make sure you have completed your request and/or finished your inquiry before the session ends',

  // Help
  'help:contact-support': 'Contact and Support',
  'help:solve-doubts':
    'This is the place to get answers to all your questions.',
  'help:attend-email': 'We also assist you via email',
  'help:solve-problems-remotely': 'We’ll solve your problem remotely',
  'help:team-viewer-info':
    'If you need remote support, our technical team will ask for your permission to access the client portal remotely. You’ll need to have one of the following programs installed:',
  'help:team-viewer-download': 'Download TeamViewer',
  'help:any-desk-download': 'Download AnyDesk',
  'help:what-is-remote-control': 'What is remote control?',
  'help:remote-control-info':
    'Using remote control applications such as TeamViewer, we can help you resolve your issues quickly and effectively while ensuring your privacy in accordance with <link>current law</link>.',
  'help:minimum-system-requirements': 'Minimum system requirements:',
  'help:browsers': 'Windows 7, Windows 8, Windows 8.1, Windows 10',
  'help:browsers-2':
    'Internet Explorer 9 or later, Mozilla Firefox, Chrome, etc.',
  'help:user-manual': 'Download the user manual',
  'help:remote-support': 'Remote Support',
  'help:new-user-manual-alert':
    'We’ve updated our platform. Learn about the new features. <link>Download the user manual here</link>.',
  'help:user-manual-info':
    'Learn how to use the portal',
  'help:write-your-message-here': 'Leave us a message here',
  'help:user-manual-download': 'Download the CTT User Manual',
  'help:customer-support': 'Customer Support',
  'help:informatic-support': 'Web Technical Support',
  'help:other-integrations': 'Other Integrations',
  'help:commercial': 'Commercial',
  'help:billing': 'Billing',
  'help:area': 'Area',
  'help:reason': 'Reason',
  'help:contact-form-info':
    'We will not use your email or phone number for anything unrelated to this inquiry.',
  'help:send': 'Send',
  'help:download-user-manual': 'Download User Manual',
  'help:see-videos': 'Watch Tutorial Videos',
  'help:videos': 'Explanatory videos',
  'help:videos-text':
    'With the following videos, you can learn any feature of this app in just a few minutes:',
  'help:success-form-sent':
    'We’ve received your message. We’ll get back to you shortly.',
  'help:subject:placeholder': 'Short description',
  'help:description:placeholder':
    'Please explain the details of your message here.',
  'help:shipmentNumber:placeholder': 'Enter your shipment number',
  'help:claim-shipment-success': 'Your inquiry has been submitted',
  'help:claim-shipment-success-body':
    'We have successfully recorded your inquiry. <p>We will respond as soon as possible.</p>',
  'help:claim-shipment-error': 'Error sending your inquiry',
  'help:claim-shipment-error-body':
    'We were unable to register your inquiry. <p>Please try again in a few minutes.</p>',
  'help:claim-shipment-save': 'The changes you made will not be saved',
  'help:claim-shipment-save-body':
    'If you return to the previous screen, you will lose the information you entered.',
  'help:shipping-tracking-c-2':
    "I requested a pickup, but they haven't come to the address I provided.",
  'help:shipping-tracking-c-3':
    'The shipment is listed as picked up, but no one has come to pick it up.',
  'help:shipping-tracking-c-1':
    'The reported issue is incorrect, and I need the shipment to be picked up.',
  'help:shipping-tracking-c-4': 'I need help resolving an issue.',
  'help:shipping-tracking-c-5':
    'I need help with a pickup at a Pick&Drop Point.',
  'help:shipping-tracking-c-6': 'The delivery person behaved inappropriately.',

  'help:shipping-tracking-d-1':
    "The shipment hasn't arrived, even though it should have been delivered by now.",
  'help:shipping-tracking-d-2':
    'The issue reported regarding the delivery is incorrect.',
  'help:shipping-tracking-d-3': 'I need help resolving an issue.',
  'help:shipping-tracking-d-4':
    'I need help with a delivery to a Pick&Drop Point.',
  'help:shipping-tracking-d-5':
    "The shipment is marked as delivered, but the recipient hasn't received it.",
  'help:shipping-tracking-d-6': 'The shipment arrived damaged.',
  'help:shipping-tracking-d-7': 'The delivery person behaved inappropriately.',
  'help:shipping-tracking-alert':
    'We will not use your email or phone number for anything unrelated to this inquiry.',
  // Business
  'shipping-state:WEB0000:name': 'DECLARED',
  'shipping-state:WEB0000:description':
    'SHIPMENT REGISTERED: CTT EXPRESS WAITING TO RECEIVE THE GOODS',
  'shipping-state:WEB0100:name': 'PICKUP ORDER',
  'shipping-state:WEB0100:description':
    'PICKUP RECORDED: CTT EXPRESS WAITING TO PICK UP THE MERCHANDISE',
  'shipping-state:WEB0200:name': 'PICKUP PENDING ACCEPTANCE',

  'shipping-state:WEB0300:name': 'PICKUP ASSIGNED',
  'shipping-state:WEB0300:description': 'PICKUP ASSIGNED TO DRIVER',
  'shipping-state:WEB0400:name': 'PICKUP CANCELED',
  'shipping-state:WEB0400:description': 'PICKUP CANCELED',
  'shipping-state:WEB0500:name': 'SHIPMENT PICKED UP',
  'shipping-state:WEB0500:description': 'PICKUP COMPLETED',
  'shipping-state:WEB0600:name': 'PICKUP FAILED',
  'shipping-state:WEB0600:description': 'PICKUP FAILED',
  'shipping-state:WEB0700:name': 'ORIGIN BRANCH',
  'shipping-state:WEB0700:description': 'GOODS AT ORIGIN BRANCH',
  'shipping-state:WEB0800:name': 'BEING LOADED',

  'shipping-state:WEB0900:name': 'IN TRANSIT',
  'shipping-state:WEB0900:description': 'SHIPMENT IN PROGRESS',
  'shipping-state:WEB1000:name': 'TRANSIT PLATFORM',

  'shipping-state:WEB1100:name': 'TRANSIT ERROR "EXCESS"',
  'shipping-state:WEB1100:description': 'SHIPMENT WITH INCORRECT TRANSIT',
  'shipping-state:WEB1200:name': 'DESTINATION BRANCH',
  'shipping-state:WEB1200:description': 'GOODS AT DESTINATION BRANCH',
  'shipping-state:WEB1300:name': 'PRE-ASSIGNED DELIVERY',

  'shipping-state:WEB1400:name': 'ASSIGNED DELIVERY',
  'shipping-state:WEB1400:description': 'DELIVERY ASSIGNED TO DRIVER',
  'shipping-state:WEB1500:name': 'IN DELIVERY',
  'shipping-state:WEB1500:description': 'SHIPMENT BEING DELIVERED',
  'shipping-state:WEB1600:name': 'DELIVERY FAILED',
  'shipping-state:WEB1600:description': 'DELIVERY FAILED',
  'shipping-state:WEB1700:name': 'HELD',
  'shipping-state:WEB1700:description':
    'SHIPMENT TEMPORARILY STORED ("LOCATION")',
  'shipping-state:WEB1800:name': 'PARKED AND LOCATED',

  'shipping-state:WEB1900:name': 'PENDING PICKUP',

  'shipping-state:WEB2000:name': 'PARTNER DELIVERY',
  'shipping-state:WEB2000:description': 'DELIVERED TO DELIVERY PARTNER',
  'shipping-state:WEB2100:name': 'DELIVERY DELIVERED',

  'shipping-state:WEB2200:name': 'PARTIAL DELIVERY',
  'shipping-state:WEB2200:description': 'PARTIALLY DELIVERED',
  'shipping-state:WEB2310:name': 'DEPOSITED AT CTT LOCATION',
  'shipping-state:WEB2310:description': 'AVAILABLE FOR PICKUP',
  'shipping-state:WEB2400:name': 'NEW DELIVERY',
  'shipping-state:WEB2400:description': 'GOODS AT DESTINATION BRANCH',
  'shipping-state:WEB2500:name': 'RETURNS',
  'shipping-state:WEB2500:description': 'RETURNED SHIPMENT',
  'shipping-state:WEB2600:name': 'RESHIPPED/REDIRECTED',

  'shipping-state:WEB2700:name':
    'REGULATORY WAREHOUSE ("NOT PROCESSED," "DESTROYED")',
  'shipping-state:WEB2700:description':
    'CLOSED INCIDENT FILE: Incident file closed and handled by the originator. Contact the sender for more information.',
  'shipping-state:WEB2800:name': 'NOT LOCATED',
  'shipping-state:WEB2800:description':
    'LOCATION NOT CONFIRMED: An issue has occurred during the transit of your shipment. Please contact the sender. You can check the updated status of your shipment at www.cttexpress.com',
  'shipping-state:WEB2900:name': 'PICK UP AT BRANCH',

  // Print settings
  'print-settings:title': 'Print settings',
  'print-settings:label-printing-configuration': 'Label Printing Settings',
  'print-settings:problems-installing-the-app':
    'Having trouble installing the app?',
  'print-settings:app-jspm-no-installed':
    "It appears you haven't installed the JSPM app yet, or it isn't up to date. Remember to restart your browser once you've installed the component.",
  'print-settings:app-jspm-explanation':
    'To streamline high-volume label printing, we recommend installing JSPrintManager (JSPM). Please allow browser permissions when prompted.',

  'print-settings:install-jsprintmanager':
    'Install the JSPrintManager application',
  'print-settings:printer': 'Printer',
  'print-settings:no-printer': 'No printers are configured',
  'print-settings:reload-printers': 'Refresh printer list',
  'print-settings:print-type': 'Print type',
  'print-settings:print-model': 'Print model',
  'print-settings:model-single': 'A6 (10.5 x 14.8 cm)',
  'print-settings:model-single-description': '1 label per page',
  'print-settings:model-multi1': 'A4 (29.7 x 21 cm)',
  'print-settings:model-multi1-description': '1 label per page',
  'print-settings:model-multi3': 'A4 (21 x 29.7 cm)',
  'print-settings:model-multi3-description': '3 labels per page',
  'print-settings:model-multi4': 'A4 (29.7 x 21 cm)',
  'print-settings:model-multi4-description': '4 labels per page',
  'print-settings:print-position:ask-always': 'Always ask',
  'print-settings:print-position:1': '1st position',
  'print-settings:print-position:2': '2nd position',
  'print-settings:print-position:3': '3rd position',
  'print-settings:print-position:4': '4th position',
  'print-settings:we-help-you': "Get in touch—we're here to help.",
  'print-settings:support-link': 'soporte.web@cttexpress.com',
  'print-settings:download-driver': 'Download the printer driver.',
  'print-settings:download-driver-link': 'Zebra Printer Drivers',
  'print-settings:download-print-manual-title': 'Have questions?',
  'print-settings:download-print-manual':
    'You can download the printing manual ',
  'print-settings:link-text': 'here.',
  // Print alert
  'print-alert:title': 'Print your labels faster!',
  'print-alert:description':
    'Do you usually print a lot of labels? If so, download the app and print your labels faster and easier.',
  'print-alert:download-button': 'Download the app',
  'print-alert:i-want-know-more': 'I want to know more',
  'print-alert:app-not-installed':
    "It looks like you don't have the printing app installed yet. Download it so you can print your labels.",
  'print-alert:printer-not-configured':
    "To print your labels, you'll need to configure your printer first.",
  'print-alert:cancel-print-alert':
    'Remember that you can only download and print labels for shipments with a status of “Recorded.”',

  // Download Install JSPM App
  'download-install-jspm-app:title': 'Download and install the JSPM Client app',
  'download-install-jspm-app:explanation':
    'This app will help you manage your label printing more quickly and easily. Thanks to its silent printing feature, every time you create a shipping request, your label can be printed immediately with just one click, skipping all the steps your printer normally requires.',
  'download-install-jspm-app:alert-license-title': 'Terms and Conditions',
  'download-install-jspm-app:alert-license-content':
    'By clicking “Download,” you are accepting the <link>Software License Agreement and JSPM’s Privacy Policy.</link>',
  'download-install-jspm-app:recommended-version': 'Recommended Version',
  'download-install-jspm-app:helper-text-instructions':
    'To configure label printing, you need the JSPrintManager (JSPM) software. Be sure to read the instructions carefully before proceeding with the installation. Download the software safely and for free below.',
  'download-install-jspm-app:alert-recommended-version-not-obtained-content':
    'A recommended version for your computer could not be found. Please visit the <link>JSPM Client</link> page to find the version that best suits your device.',
  'download-install-jspm-app:url': 'fasd',
  'download-install-jspm-app:other-version':
    'If you need to download a version other than the recommended one, go to the <link>JSPM Client</link> page.',
  'download-install-jspm-app:installation-instructions':
    'Installation Instructions',
  'download-install-jspm-app:instructions-name':
    'Instruction Manual {operatingSystem}',
  'download-install-jspm-app:obtaining-installable': 'Obtaining the Executable',
  'download-install-jspm-app:obtaining-instructions': 'Obtaining Instructions',

  // Print modal
  'choose-position-print-labels':
    'Choose the position where you want to start printing your labels',
  // TODO: @dev: dinamizar número y plural de palabra etiqueta según cantidad de etiquetas
  'your-are-going-to-print-number-labels':
    'You are going to print a total of {shippingsCount, plural, one {1 label} other {{shippingsCount} labels}}.',
  // TODO: @dev: dinamizar modelo y número de etiquetas
  'alert-print-modal:model-number-of-labels':
    'A4 (29.7 x 21 cm) - 4 labels per page',
  'default-printing-model': 'Default print model',
  'change-model-size-on-print-settings':
    'You can change this selection in the <link>Print Settings</link>',
  'print-modal:label-print-position': 'Print Position',
  'print-modal:print-position-tooltip':
    'Choose the position from which you want your labels to start printing.',
  'print-modal:title': 'Printing',
  'print-modal:body': 'The label has been sent to the printer',
  'print-modal:first-position': '1st position',
  'print-modal:second-position': '2nd position',
  'print-modal:third-position': '3rd position',
  'print-modal:fourth-position': '4th position',

  // User zone
  'user-zone:welcome':
    '{name, select, unnamed {Welcome} other {Welcome, {name}} }',
  'user-zone:explanation':
    'Here you can view your contact information and update your password.',
  'user-zone:contact-person': 'Contact Person',
  'user-zone:contact-data': 'Contact information',
  'user-zone:client-code': 'Client code',
  'user-zone:change-contact-data': 'Change contact information',
  'user-zone:contact-data-saved': 'Your contact information has been saved.',
  'user-zone:contact-explanation':
    'We’ll use this information to contact you when necessary. You can change it at any time. Please keep it up to date',
  'user-zone:password': 'Password',
  'user-zone:passwords-dont-match': 'The passwords do not match.',
  'user-zone:password-must-have-a-number':
    'The password must contain at least 1 number',
  'user-zone:password-must-have-an-uppercase-letter':
    'The password must contain at least 1 uppercase letter',
  'user-zone:confirm-password': 'Confirm password',
  'user-zone:password-msg-info':
    'Remember that your password must be at least 8 characters long and include 1 uppercase letter and 1 number.',
  'user-zone:change-password': 'Change Password',
  'user-zone:bad-password': 'The current password is incorrect.',
  'user-zone:password-error':
    'It looks like we have a problem. Please try again.',
  'user-zone:password-saved': 'The new password has been saved.',

  // Return
  'returns:activate:main-title':
    'Would you like to request a return for this shipment?',
  'returns:activate:main-subtitle': 'Shipping ID: {shippingCode}',
  'returns:activate:main-info': 'We’ll pick up your items via',
  'returns:activate:confirm-contact-data':
    'Please confirm your contact information:',

  'returns:activate:activate-return':
    'Would you like to activate On-Demand Pickup?',
  'returns:activate:confirm-activate-return':
    'Yes, I’d prefer that my customer choose where and when they want to return the merchandise',

  'return:activate:action:confirm': 'Yes, return merchandise',
  'return:activate:delivered-email-input': "Sender's email",
  'return:activate:delivered-email': "Sender's email for notification:",
  'returns:success:main-title': 'Your return has been successfully requested',
  'returns:success:alert':
    'Remember that you can view all your shipments and their statuses in the Tracking section of this website.',
  'returns:activate:remember-text':
    '*Please note that this merchandise will be returned to the original shipping address and that this involves a cost. For more information, please refer to your contract or contact your sales representative.',
  'return:success:action:confirm': 'Back to Tracking',

  // Unscheduled pickup
  'unscheduled-pickup:main-title': 'Schedule a pickup',
  'unscheduled-pickup:main-subtitle': 'When would you like us to pick it up?',
  'unscheduled-pickup:option:asap': 'As soon as possible',
  'unscheduled-pickup:option:chosse-day-and-hour':
    'I want to choose a day and time',
  'unscheduled-pickup:asap-info':
    'This is the date your packages will be picked up at the specified address.',
  'unscheduled-pickup:reminder':
    'Please remember that when we come to pick up these shipments, we can take all the shipments you have prepared and labeled at that time.',
  'unscheduled-pickup:confirmation-title':
    'Your pickup has been scheduled successfully',
  'unscheduled-pickup:confirmation-subtitle':
    'The changes will appear on the tracking page shortly',
  'unscheduled:success:action:confirm': 'Back to Tracking',
  'unscheduled-pickup:date:not-defined':
    'Not defined. We’ll provide the date when you schedule the pickup or the shipment is picked up.',
  'action:schedule-pickup-option':
    'Schedule {count, plural, one {pickup} other {pickups}}',
  'unscheduled-pickup:table-header-title': 'Origin Address',

  // My Clients (BK/FR)
  // Traducciones añadidas por Claude (no encontradas en el excel de traducciones)
  'delivery-point:recommended': 'Recommended!',
  'switch-label:new-product': 'New product!',
  'switch-label:recommended-product': 'Recommended Product!',
  'shipping-send-form:origin:postal-code:invalid-format-pt':
    'Please enter the 7 digits of the postal code',
  'shipping-send-form:customs:form:price-hint':
    'This value may be used by customs to calculate taxes and duties. Enter the actual amount.',
  'shipping-send-form:customs:form:price-hint-link': 'See more information',
  'shipping-send-form:customs:taric-code-ten': 'Must contain exactly 10 digits',
  'shipping-detail:return-on-delivery-number': 'Returned shipment No.:',
  'shipping-state:WEB0200:description': '',
  'shipping-state:WEB0800:description': '',
  'shipping-state:WEB1000:description': '',
  'shipping-state:WEB1300:description': '',
  'shipping-state:WEB1800:description': '',
  'shipping-state:WEB1900:description': '',
  'shipping-state:WEB2100:description': '',
  'shipping-state:WEB2600:description': '',
  'shipping-state:WEB2900:description': '',
  'print-settings:app-jspm-browser-permissions':
    'You need to grant permission to the web browser to enable this feature.',
  'print-settings:app-jspm-browser-permissions-tooltip':
    'Following the latest updates to Google Chrome and Microsoft Edge, these browsers request additional permissions to run the printing application, so you need to manually authorize it when the browser shows the corresponding notice. If you have already installed a previous version of JSPrint Manager, check the browser bar next to the web domain and enable "Allow apps on your device".',
  'noun:my-clients': 'My clients',
  'my-clients:title': 'My clients',
  'my-clients:tab:clients': 'Clients',
  'my-clients:tab:web-users': 'Web users',
  'my-clients:clients:search-placeholder':
    'Search by name, custom code or client code...',
  'my-clients:clients:empty-state': 'No clients found',
  'my-clients:clients:add-button': 'Create new client',
  'my-clients:clients:column:code': 'Code',
  'my-clients:clients:column:name': 'Name',
  'my-clients:clients:column:contact': 'Contact',
  'my-clients:clients:column:email': 'Email',
  'my-clients:clients:column:status': 'Status',
  'my-clients:clients:column:actions': 'Actions',
  'my-clients:clients:section-title': 'Find a Client',
  'my-clients:clients:action:view': 'View more',
  'my-clients:clients:action:edit': 'Edit',
  'my-clients:users:section-title': 'Configure your users',
  'my-clients:users:section-subtitle': 'Search for your user here',
  'my-clients:users:search-placeholder': 'Search user...',
  'my-clients:users:empty-state': 'No users found',
  'my-clients:users:add-button': 'Add user',
  'my-clients:users:column:email': 'Email',
  'my-clients:users:column:centers': 'Centers',
  'my-clients:users:column:status': 'Status',
  'my-clients:users:column:last-login': 'Last login',
  'my-clients:users:column:role': 'Role',
  'my-clients:users:column:actions': 'Actions',
  'my-clients:users:action:edit': 'Edit',
  'my-clients:users:action:delete': 'Delete',
  'my-clients:role:admin': 'Administrator',
  'my-clients:role:gestor': 'Manager',
  'my-clients:role:colaborador': 'Collaborator',
  'my-clients:client-drawer:title-create': 'New client',
  'my-clients:client-drawer:title-edit': 'Edit client',
  'my-clients:client-drawer:section:center-data': 'Center data',
  'my-clients:client-drawer:section:address': 'Operating address',
  'my-clients:client-drawer:section:contact': 'Contact details',
  'my-clients:client-drawer:section:address-use': 'Use this address for',
  'my-clients:client-drawer:section:returns-address': 'Returns address',
  'my-clients:client-drawer:section:pickups-address': 'Pickup address',
  'my-clients:client-drawer:section:labels-address': 'Label address',
  'my-clients:client-drawer:field:center-name': 'Center name',
  'my-clients:client-drawer:field:business-name': 'Business name',
  'my-clients:client-drawer:field:custom-code': 'Custom code',
  'my-clients:client-drawer:field:contact-name': 'Contact name',
  'my-clients:client-drawer:field:contact-email': 'Contact email',
  'my-clients:client-drawer:field:phone-prefix': 'Prefix',
  'my-clients:client-drawer:field:contact-phone': 'Phone',
  'my-clients:client-drawer:field:street': 'Street',
  'my-clients:client-drawer:field:street-number': 'Number',
  'my-clients:client-drawer:field:city': 'City',
  'my-clients:client-drawer:field:postal-code': 'Postal code',
  'my-clients:client-drawer:field:country': 'Country',
  'my-clients:client-drawer:field:use-for-returns': 'Returns',
  'my-clients:client-drawer:field:use-for-pickups': 'Pickups',
  'my-clients:client-drawer:field:use-for-labels': 'Labels',
  'my-clients:client-drawer:action:save': 'Save',
  'my-clients:client-drawer:action:cancel': 'Cancel',
  'my-clients:client-drawer:success-create': 'Client created successfully',
  'my-clients:client-drawer:success-edit': 'Client updated successfully',
  'my-clients:client-drawer:error': 'An error has occurred. Please try again.',
  'my-clients:user-drawer:title-create': 'New user',
  'my-clients:user-drawer:title-edit': 'Edit user',
  'my-clients:user-drawer:field:name': 'Name',
  'my-clients:user-drawer:field:email': 'Email',
  'my-clients:user-drawer:field:phone': 'Phone',
  'my-clients:user-drawer:field:role': 'Role',
  'my-clients:user-drawer:field:centers': 'Assigned centers',
  'my-clients:user-drawer:action:save': 'Save',
  'my-clients:user-drawer:action:cancel': 'Cancel',
  'my-clients:user-drawer:success-create':
    'User created successfully. They will receive an activation email.',
  'my-clients:user-drawer:success-edit': 'User updated successfully',
  'my-clients:user-drawer:error': 'An error has occurred. Please try again.',
  'my-clients:user-drawer:admin-centers-info':
    'The Administrator role automatically has access to all centers.',
  'my-clients:user-drawer:centers-search-placeholder': 'Search center...',
  'my-clients:user-drawer:centers-selected': '{count} centers selected',
  'my-clients:user-drawer:centers-select-all': 'ALL',
  'my-clients:delete-user:title': 'Delete user',
  'my-clients:delete-user:description':
    'Are you sure you want to delete the user {name}? This action cannot be undone.',
  'my-clients:delete-user:action:confirm': 'Yes, delete',
  'my-clients:delete-user:action:cancel': 'Cancel',
  'my-clients:delete-user:success': 'User deleted successfully',
  'my-clients:delete-user:error': 'An error occurred while deleting the user.',
  'my-clients:detail:tab:info': 'Information',
  'my-clients:detail:tab:users': 'Users',
  'my-clients:detail:tab:rates': 'Rates',
  'my-clients:detail:tab:pickup': 'Pickup',
  'my-clients:detail:back': 'Back to clients',
  'my-clients:detail:rates:placeholder': 'Rates will be available soon.',
  'my-clients:detail:pickup:placeholder':
    'Pickup configuration will be available soon.',
  'action:continue': 'Continue',
  'shipping-send-form:origin:label-customization:customize':
    'Customize label details',
  'shipping-send-form:origin:label-customization:drawer-title':
    'Customize your label',
  'shipping-send-form:origin:label-customization:drawer-title-edit':
    'Edit sender details',
  'shipping-send-form:origin:label-customization:info-title':
    'Custom label details',
  'shipping-send-form:origin:label-customization:info-text':
    'Custom fields for label:',
  'shipping-send-form:origin:label-customization:info-description-1':
    "These fields will be reflected in the sender position on the label, but will not modify the shipment's operational data.",
  'shipping-send-form:origin:label-customization:info-description-2':
    "If you leave any field blank, the label will show the shipment's original data.",
  'shipping-send-form:origin:label-customization:name-label':
    'Custom name for the shipping label',
  'shipping-send-form:origin:label-customization:address-label':
    'Custom address for the shipping label',
  'shipping-send-form:origin:label-customization:custom-name': 'Custom name',
  'shipping-send-form:origin:label-customization:custom-address':
    'Custom address',
  'shipping-send-form:origin:label-customization:delete':
    'Delete custom details',

  // Traducción añadida por Claude (no encontrada en el excel de traducciones)
  'shipping-send-form:shipment:eu-regulation-warning-24h-es-pt':
    'New European regulations applicable to international transport may affect delivery times for 24h shipments from Spain to Portugal.',
}

export default EN
